window.addEventListener("load", function () {
  (function ($) {
    // ============ PLAYER DATABASE ============
    // Compact format: [player_id, common_name]
    var players = [
      [80000, "Kylian Mbappe", "CF"],
      [80001, "Mohamed Salah", "RW"],
      [80002, "Ousmane Dembele", "RW"],
      [80003, "Raphinha", "LW"],
      [80004, "Virgil Van Dijk", "CB"],
      [80005, "Erling Haaland", "CF"],
      [80006, "Jude Bellingham", "AMF"],
      [80007, "Harry Kane", "CF"],
      [80008, "Lamine Yamal", "RW"],
      [80009, "Lautaro Martinez", "CF"],
      [80010, "Federico Valverde", "CMF"],
      [80011, "Vinicius Junior", "LW"],
      [80012, "William Saliba", "CB"],
      [80013, "Bukayo Saka", "RW"],
      [80014, "Declan Rice", "CMF"],
      [80015, "Nicolo Barella", "CMF"],
      [80017, "Gianluigi Donnarumma", "GK"],
      [80018, "Achraf Hakimi", "RB"],
      [80016, "Florian Wirtz", "AMF"],
      [80019, "Thibaut Courtois", "GK"],
      [80020, "Kevin De Bruyne", "AMF"],
      [80021, "Scott McTominay", "CMF"],
      [80022, "Antonio Rudiger", "CB"],
      [80023, "Bruno Fernandes", "AMF"],
      [80024, "Robert Lewandowski", "CF"],
      [80025, "Cristiano Ronaldo", "CF"],
      [80026, "Lionel Messi", "RW"],
      [80027, "Bernardo Silva", "AMF"],
      [80028, "Ruben Dias", "CB"],
      [80029, "Rodri", "DMF"],
      [80030, "Pedri", "CMF"],
      [80031, "Antoine Griezmann", "AMF"],
      [80032, "Mike Maignan", "GK"],
      [80033, "Jamal Musiala", "AMF"],
      [80034, "Michael Olise", "RW"],
      [80035, "Alessandro Bastoni", "CB"],
      [80036, "Vitor Ferreira", "CMF"],
      [80037, "Hakan Calhanoglu", "DMF"],
      [80038, "Karim Benzema", "CF"],
      [80039, "Heung-Min Son", "LW"],
      [80040, "Martin Odegaard", "AMF"],
      [80041, "Cole Palmer", "AMF"],
      [80042, "Alisson", "GK"],
      [80044, "Jan Oblak", "GK"],
      [80045, "Gregor Kobel", "GK"],
      [80046, "Marquinhos", "CB"],
      [80047, "Khvicha Kvaratskhelia", "LW"],
      [80048, "Rafael Leo", "LW"],
      [80049, "Giovanni Di Lorenzo", "RB"],
      [80050, "Amir Rrahmani", "CB"],
      [80051, "Tijjani Reijnders", "CMF"],
      [80052, "Julian Alvarez", "CF"],
      [80053, "Frenkie De Jong", "CMF"],
      [80054, "Luis Diaz", "LW"],
      [80055, "Nuno Mendes", "LB"],
      [80043, "Rodrygo", "RW"],
      [80057, "Joshua Kimmich", "DMF"],
      [80058, "Luka Modric", "CMF"],
      [80059, "N'Golo Kante", "DMF"],
      [80060, "Victor Osimhen", "CF"],
      [80061, "Viktor Gykeres", "CF"],
      [80062, "Bruno Guimaraes", "DMF"],
      [80063, "Ederson", "GK"],
      [80064, "Phil Foden", "RW"],
      [80065, "Bremer", "CB"],
      [80066, "Paulo Dybala", "AMF"],
      [80067, "Xavi Simons", "AMF"],
      [80068, "Gabriel", "CB"],
      [80069, "David Raya", "GK"],
      [80070, "Josko Gvardiol", "LB"],
      [80071, "Alexander Isak", "CF"],
      [80072, "James Maddison", "AMF"],
      [80073, "Ollie Watkins", "CF"],
      [80074, "Emiliano Martinez", "GK"],
      [80075, "Dani Olmo", "AMF"],
      [80076, "Federico Dimarco", "LB"],
      [80077, "Denzel Dumfries", "RB"],
      [80078, "Christian Pulisic", "RW"],
      [80079, "Artem Dovbyk", "CF"],
      [80080, "Alejandro Grimaldo", "LB"],
      [80081, "Marcus Thuram", "CF"],
      [80082, "Dayot Upamecano", "CB"],
      [80083, "Nico Williams", "LW"],
      [80084, "Isco", "AMF"],
      [80105, "Serhou Guirassy", "CF"],
      [80114, "Lucas Chevalier", "GK"],
      [80115, "Matheus Cunha", "AMF"],
      [80056, "Theo Hernandez", "LB"],
      [80085, "Joao Cancelo", "RB"],
      [80086, "Julian Brandt", "AMF"],
      [80087, "Jonathan Tah", "CB"],
      [80088, "Romelu Lukaku", "CF"],
      [80089, "Marc-Andre Ter Stegen", "GK"],
      [80090, "Ilkay Gundogan", "CMF"],
      [80091, "Daniel Carvajal", "RB"],
      [80092, "Mikel Merino", "CMF"],
      [80093, "Savio De Oliveira", "RW"],
      [80094, "Andrew Robertson", "LB"],
      [80095, "Alexis Allister", "CMF"],
      [80096, "Trent Alexander-Arnold", "RB"],
      [80097, "Giorgi Mamardashvili", "GK"],
      [80098, "Aurelien Tchouameni", "DMF"],
      [80099, "Jules Kounde", "RB"],
      [80100, "Ronald Araujo", "CB"],
      [80101, "Unai Simon", "GK"],
      [80102, "Benjamin Pavard", "CB"],
      [80103, "Jeremie Frimpong", "RB"],
      [80104, "Manuel Neuer", "GK"],
      [80106, "Diogo Costa", "GK"],
      [80107, "Sandro Tonali", "CMF"],
      [80108, "Alex Meret", "GK"],
      [80109, "Matteo Politano", "RW"],
      [80110, "Andre Anguissa", "CMF"],
      [80111, "Alessandro Buongiorno", "CB"],
      [80112, "Fabian Ruiz", "CMF"],
      [80113, "Desire Doue", "RW"],
      [80116, "Noussair Mazraoui", "RB"],
      [80117, "Marcos Llorente", "RB"],
      [80118, "Adrien Rabiot", "CMF"],
      [80119, "Bryan Mbeumo", "RW"],
      [80120, "Rayan Cherki", "RW"],
      [80121, "Ryan Gravenberch", "DMF"],
      [80122, "Stanislav Lobotka", "DMF"],
      [80131, "Marc Cucurella", "LB"],
      [80184, "Martin Ibaez", "DMF"],
      [80442, "Joan Pons", "GK"],
      [80600, "Mateo Retegui", "CF"],
      [80123, "Eder Militao", "CB"],
      [80124, "Yann Sommer", "GK"],
      [80125, "Granit Xhaka", "DMF"],
      [80126, "Casemiro", "DMF"],
      [80127, "Manuel Akanji", "CB"],
      [80128, "Leandro Trossard", "LW"],
      [80129, "Ben White", "RB"],
      [80130, "Jeremy Doku", "LW"],
      [80132, "Pedro Porro", "RB"],
      [80133, "Guglielmo Vicario", "GK"],
      [80134, "Matthijs De Ligt", "CB"],
      [80135, "Lisandro Martinez", "CB"],
      [80136, "Anthony Gordon", "LW"],
      [80137, "Jarrod Bowen", "RW"],
      [80138, "Ferland Mendy", "LB"],
      [80139, "Robin Le Normand", "CB"],
      [80140, "Alexander Srloth", "CF"],
      [80141, "Alex Remiro", "GK"],
      [80142, "Manuel Locatelli", "DMF"],
      [80143, "David De Gea", "GK"],
      [80144, "Douglas Luiz", "CMF"],
      [80145, "Leon Goretzka", "CMF"],
      [80146, "Nico Schlotterbeck", "CB"],
      [80147, "Mason Greenwood", "RW"],
      [80148, "Bono", "GK"],
      [80149, "Ederson Dos Santos", "CMF"],
      [80150, "Antony", "RW"],
      [80151, "N Lang", "LW"],
      [80152, "Miguel Ortega", "LB"],
      [80153, "Eberechi Eze", "AMF"],
      [80154, "Ibrahima Konate", "CB"],
      [80155, "Alejandro Rodriguez", "LW"],
      [80156, "Nicolas Martinez", "AMF"],
      [80157, "Mohammed Kudus", "RW"],
      [80158, "Alejandro Martinez", "LB"],
      [80159, "Joao Neves", "CMF"],
      [80160, "Enzo Fernandez", "CMF"],
      [80161, "Joelinton", "CMF"],
      [80162, "Ademola Lookman", "AMF"],
      [80163, "Hugo Ekitike", "CF"],
      [80164, "Cristian Romero", "CB"],
      [80165, "Marc Guehi", "CB"],
      [80218, "Moises Corozo", "DMF"],
      [80309, "Bradley Barcola", "LW"],
      [80166, "Francesco Acerbi", "CB"],
      [80167, "Christopher Nkunku", "CF"],
      [80168, "Teun Koopmeiners", "AMF"],
      [80169, "Leroy Sane", "RW"],
      [80170, "Rodrigo De Paul", "CMF"],
      [80171, "Henrikh Mkhitaryan", "CMF"],
      [80172, "Alvaro Morata", "CF"],
      [80173, "Youssouf Fofana", "DMF"],
      [80174, "Riccardo Calafiori", "LB"],
      [80175, "Gabriel Martinelli", "LW"],
      [80176, "Destiny Udogie", "LB"],
      [80177, "Aaron Ramsdale", "GK"],
      [80178, "Youri Tielemans", "CMF"],
      [80179, "Mitoma", "LW"],
      [80180, "Niclas Fullkrug", "CF"],
      [80181, "Jack Grealish", "LW"],
      [80182, "Jordan Pickford", "GK"],
      [80185, "David Alaba", "CB"],
      [80186, "Eduardo Camavinga", "CMF"],
      [80187, "Viktor Tsygankov", "RW"],
      [80188, "Iago Aspas", "CF"],
      [80189, "Piotr Zielinski", "CMF"],
      [80190, "Davide Frattesi", "CMF"],
      [80191, "Dusan Vlahovic", "CF"],
      [80192, "Fikayo Tomori", "CB"],
      [80193, "Mattia Zaccagni", "LW"],
      [80194, "Kingsley Coman", "LW"],
      [80195, "Joao Palhinha", "DMF"],
      [80196, "Kim Min-jae", "CB"],
      [80197, "Marcel Sabitzer", "CMF"],
      [80198, "Pascal Gro", "CMF"],
      [80199, "Lukas Hradecky", "GK"],
      [80200, "Kevin Trapp", "GK"],
      [80201, "Ismael Bennacer", "DMF"],
      [80202, "Lucas Hernandez", "LB"],
      [80203, "Pierre-Emile Hojbjerg", "DMF"],
      [80204, "Geronimo Rulli", "GK"],
      [80205, "Vangelis Pavlidis", "CF"],
      [80206, "Domenico Berardi", "RW"],
      [80207, "Marcelo Brozovic", "DMF"],
      [80208, "Wojciech Szczesny", "GK"],
      [80209, "Cody Gakpo", "LW"],
      [80210, "Dominik Szoboszlai", "AMF"],
      [80211, "Harry Maguire", "CB"],
      [80212, "Thomas Partey", "DMF"],
      [80213, "Brahim Diaz", "RW"],
      [80214, "Antonee Robinson", "LB"],
      [80215, "Warren Zare-Emery", "CMF"],
      [80216, "Kenan Yldz", "LW"],
      [80217, "Michele Di Gregorio", "GK"],
      [80219, "Giovani Celso", "AMF"],
      [80220, "Omar Marmoush", "CF"],
      [80221, "Jonathan David", "CF"],
      [80223, "Ivan Toney", "CF"],
      [80224, "Moussa Diaby", "RW"],
      [80225, "Lucas Beraldo", "CB"],
      [80226, "Willian Pacho", "CB"],
      [80227, "James Tarkowski", "CB"],
      [80235, "Reece James", "RB"],
      [80424, "Matz Sels", "GK"],
      [80183, "Kyle Walker", "RB"],
      [80229, "Nicolas Otamendi", "CB"],
      [80230, "Luis Suarez", "CF"],
      [80231, "Marco Asensio", "AMF"],
      [80232, "Kai Havertz", "CF"],
      [80233, "Nathan Ake", "CB"],
      [80234, "John Stones", "CB"],
      [80236, "Rodrigo Bentancur", "DMF"],
      [80237, "Dejan Kulusevski", "AMF"],
      [80238, "Manuel Ribeiro", "DMF"],
      [80239, "Kieran Trippier", "RB"],
      [80240, "Fabian Schr", "CB"],
      [80241, "Nick Pope", "GK"],
      [80242, "Sven Botman", "CB"],
      [80243, "Daniel Munoz", "RB"],
      [80244, "Guido Rodriguez", "DMF"],
      [80245, "Aaron Wan-Bissaka", "RB"],
      [80246, "Marcus Rashford", "LW"],
      [80247, "Mark Flekken", "GK"],
      [80248, "Inigo Martinez", "CB"],
      [80249, "Andriy Lunin", "GK"],
      [80250, "Jose Gimenez", "CB"],
      [80251, "Dani Vivian", "CB"],
      [80252, "Takefusa Kubo", "RW"],
      [80253, "Dani Parejo", "CMF"],
      [80254, "Ante Budimir", "CF"],
      [80255, "Sergi Darder", "CMF"],
      [80256, "David Soria", "GK"],
      [80257, "Ruben Loftus-Cheek", "CMF"],
      [80258, "Marco Carnesecchi", "GK"],
      [80259, "Lorenzo Pellegrini", "AMF"],
      [80260, "Gianluca Mancini", "CB"],
      [80261, "Bryan Cristante", "DMF"],
      [80262, "Alessio Romagnoli", "CB"],
      [80263, "Boulaye Dia", "CF"],
      [80264, "Ivan Provedel", "GK"],
      [80265, "Matteo Guendouzi", "CMF"],
      [80266, "Wladimiro Falcone", "GK"],
      [80267, "Lois Openda", "CF"],
      [80268, "Thomas Muller", "AMF"],
      [80269, "Raphael Guerreiro", "LB"],
      [80270, "Serge Gnabry", "LW"],
      [80271, "Niklas Sule", "CB"],
      [80272, "Waldemar Anton", "CB"],
      [80273, "Exequiel Palacios", "CMF"],
      [80274, "Aleix Serrano", "CMF"],
      [80275, "Robert Andrich", "DMF"],
      [80276, "Patrik Schick", "CF"],
      [80277, "Martin Terrier", "LW"],
      [80278, "Willi Orban", "CB"],
      [80279, "Peter Gulacsi", "GK"],
      [80280, "Alexander Nubel", "GK"],
      [80281, "Maximilian Arnold", "CMF"],
      [80282, "Matthias Ginter", "CB"],
      [80283, "Milan Skriniar", "CB"],
      [80284, "Thiago Almada", "AMF"],
      [80285, "Aleksandr Golovin", "AMF"],
      [80286, "Benjamin Andre", "DMF"],
      [80287, "Jonathan Clauss", "RB"],
      [80288, "Joey Veerman", "CMF"],
      [80289, "Pedro Goncalves", "LW"],
      [80290, "Ricardo Horta", "RW"],
      [80291, "Orkun Kkcu", "CMF"],
      [80292, "Ciro Immobile", "CF"],
      [80293, "Nacho Fernandez", "CB"],
      [80294, "Lucas Torreira", "DMF"],
      [80295, "Rafa Silva", "AMF"],
      [80296, "Pierre-Emerick Aubameyang", "CF"],
      [80297, "Otavio", "AMF"],
      [80298, "Aymeric Laporte", "CB"],
      [80299, "Sergio Busquets", "DMF"],
      [80300, "Denis Bouanga", "LW"],
      [80301, "Ferran Torres", "CF"],
      [80302, "Eric Dier", "CB"],
      [80303, "Alexis Saelemaekers", "RW"],
      [80304, "Moise Kean", "CF"],
      [80305, "Dean Huijsen", "CB"],
      [80306, "Antonio Silva", "CB"],
      [80307, "Arda Guler", "AMF"],
      [80308, "Yeray Alvarez", "CB"],
      [80310, "Illia Zabarnyi", "CB"],
      [80311, "Rayan Nouri", "LB"],
      [80312, "Yoane Wissa", "CF"],
      [80313, "Benjamin Sesko", "CF"],
      [80314, "Joao Pedro", "CF"],
      [80315, "Pierre Kalulu", "CB"],
      [80316, "Alvaro Carreras", "LB"],
      [80357, "Vanja Milinkovi-Savi", "GK"],
      [80404, "Milos Kerkez", "LB"],
      [80521, "Levi Colwill", "CB"],
      [80590, "E Ndicka", "CB"],
      [80712, "Mile Svilar", "GK"],
      [80222, "Igor Da Paixo", "LW"],
      [80228, "Andre Onana", "GK"],
      [80317, "Mateo Kovacic", "CMF"],
      [80318, "Luuk De Jong", "CF"],
      [80319, "Pervis Estupian", "LB"],
      [80320, "Gabriel Jesus", "CF"],
      [80321, "Federico Chiesa", "RW"],
      [80322, "Dominic Solanke", "CF"],
      [80323, "Mickey Van De Ven", "CB"],
      [80324, "Luke Shaw", "LB"],
      [80325, "Diogo Dalot", "RB"],
      [80326, "Harvey Barnes", "LW"],
      [80327, "Morgan Gibbs-White", "AMF"],
      [80328, "Nikola Milenkovic", "CB"],
      [80329, "Ezri Konsa", "CB"],
      [80330, "Jadon Sancho", "LW"],
      [80331, "Pau Torres", "CB"],
      [80332, "Francisco Barbosa", "CF"],
      [80333, "Jean-Clair Todibo", "CB"],
      [80334, "Lucas Paqueta", "AMF"],
      [80335, "James Ward-Prowse", "CMF"],
      [80336, "Bernd Leno", "GK"],
      [80337, "Nicolas Jackson", "CF"],
      [80338, "Raheem Sterling", "RW"],
      [80339, "Pablo Gavira", "CMF"],
      [80340, "Andreas Christensen", "CB"],
      [80341, "Nahuel Molina", "RB"],
      [80342, "Koke", "CMF"],
      [80343, "Inaki Williams", "RW"],
      [80344, "Oihan Sancet", "AMF"],
      [80345, "Alex Berenguer", "LW"],
      [80346, "Yangel Herrera", "CMF"],
      [80347, "Mikel Oyarzabal", "CF"],
      [80348, "Juan Foyth", "CB"],
      [80349, "Gerard Moreno", "CF"],
      [80350, "Daley Blind", "CB"],
      [80351, "Paulo Gazzaniga", "GK"],
      [80352, "Isaac Camacho", "AMF"],
      [80353, "Lucas Vazquez", "RB"],
      [80354, "Carlos Neves", "LB"],
      [80355, "Stefan De Vrij", "CB"],
      [80356, "David Neres", "RW"],
      [80358, "Mario Pasalic", "CMF"],
      [80359, "Marten De Roon", "DMF"],
      [80360, "Matias Malvano", "RW"],
      [80361, "Riccardo Orsolini", "RW"],
      [80362, "Duvan Zapata", "CF"],
      [80363, "Randal Muani", "CF"],
      [80364, "Samuel Chukwueze", "RW"],
      [80365, "Juan Musso", "GK"],
      [80366, "Eduardo Cossa", "RW"],
      [80367, "Piero Hincapie", "CB"],
      [80368, "Donyell Malen", "RW"],
      [80369, "Konrad Laimer", "RB"],
      [80370, "Emre Can", "DMF"],
      [80371, "Jonas Hofmann", "AMF"],
      [80372, "D Raum", "LB"],
      [80373, "B Henrichs", "RB"],
      [80374, "Deniz Undav", "CF"],
      [80375, "Maximilian Mittelstdt", "LB"],
      [80376, "Oliver Baumann", "GK"],
      [80377, "Andrej Kramaric", "AMF"],
      [80378, "Vincenzo Grifo", "LW"],
      [80379, "Marcin Bulka", "GK"],
      [80380, "Alexandre Lacazette", "CF"],
      [80381, "Ore Petrovi", "GK"],
      [80382, "Facundo Medina", "CB"],
      [80383, "Brice Samba", "GK"],
      [80384, "Jordan Henderson", "DMF"],
      [80385, "David Hancko", "CB"],
      [80386, "Malik Tillman", "AMF"],
      [80387, "Hamari Traore", "RB"],
      [80388, "Lars Unnerstall", "GK"],
      [80389, "Morten Hjulmand", "DMF"],
      [80390, "Goncalo Inacio", "CB"],
      [80391, "Francisco Trinco", "RW"],
      [80392, "Fredrik Aursnes", "CMF"],
      [80393, "Florentino", "DMF"],
      [80394, "Simon Banza", "CF"],
      [80395, "Danilo Pereira", "CB"],
      [80396, "Yannick Carrasco", "LW"],
      [80397, "Chris Smalling", "CB"],
      [80398, "Youssef En-Nesyri", "CF"],
      [80399, "Davinson Sanchez", "CB"],
      [80400, "Koen Casteels", "GK"],
      [80401, "Jordi Alba", "LB"],
      [80402, "Ardon Jashari", "DMF"],
      [80403, "Matteo Gabbia", "CB"],
      [80405, "Angelo Damaceno", "RW"],
      [80406, "Carlos Baleba", "DMF"],
      [80407, "Pedro Neto", "RW"],
      [80408, "Federico Gatti", "CB"],
      [80409, "Rico Lewis", "RB"],
      [80410, "Matheus Nunes", "CMF"],
      [80415, "Darwin Nuez", "CF"],
      [80441, "Dani Ceballos", "CMF"],
      [80484, "Kang-In Lee", "RW"],
      [81406, "Mathys Tel", "CF"],
      [81407, "Nick Woltemade", "AMF"],
      [80411, "Kepa Arrizabalaga", "GK"],
      [80412, "Andrey Dos Santos", "CMF"],
      [80413, "Aitor Fernandez", "GK"],
      [80414, "Olivier Giroud", "CF"],
      [80416, "Joao Felix", "AMF"],
      [80417, "Malo Gusto", "RB"],
      [80418, "Robert Sanchez", "GK"],
      [80419, "Richarlison", "CF"],
      [80420, "Kevin Danso", "CB"],
      [80421, "Joshua Zirkzee", "CF"],
      [80422, "Kobbie Mainoo", "CMF"],
      [80423, "Murillo Dos Santos", "CB"],
      [80425, "John McGinn", "CMF"],
      [80426, "Lucas Digne", "LB"],
      [80427, "Boubacar Kamara", "DMF"],
      [80428, "Mats Wieffer", "DMF"],
      [80429, "Ferdi Kadolu", "LB"],
      [80430, "Dean Henderson", "GK"],
      [80431, "Jean-Philippe Mateta", "CF"],
      [80432, "Alphonse Areola", "GK"],
      [80433, "Tomas Soucek", "DMF"],
      [80434, "Kiernan Dewsbury-Hall", "CMF"],
      [80435, "Jarrad Branthwaite", "CB"],
      [80436, "Alex Iwobi", "LW"],
      [80437, "Timo Werner", "LW"],
      [80438, "Jurrien Timber", "RB"],
      [80439, "Rui Silva", "GK"],
      [80440, "Dodi Lukebakio", "RW"],
      [80443, "Conor Gallagher", "CMF"],
      [80444, "Javier Gil", "LB"],
      [80445, "Inigo Etxeberria", "CMF"],
      [80446, "Igor Zubeldia", "CB"],
      [80447, "Brais Mendez", "AMF"],
      [80448, "Ayoze Perez", "CF"],
      [80449, "Pepelu", "DMF"],
      [80450, "Jose Gaya", "LB"],
      [80451, "Ivan Nuez", "AMF"],
      [80452, "Arnau Lopez", "RB"],
      [80453, "Axel Witsel", "CB"],
      [80454, "Nemanja Gudelj", "DMF"],
      [80455, "Sergio Piron", "GK"],
      [80456, "Alejandro Marugan", "CB"],
      [80457, "Pablo Maffeo", "RB"],
      [80458, "Vedat Muriqi", "CF"],
      [80459, "Alvaro Garcia", "LW"],
      [80460, "Florian Lejeune", "CB"],
      [80461, "Nayef Aguerd", "CB"],
      [80462, "Matteo Darmian", "RB"],
      [80463, "Sead Kolasinac", "CB"],
      [80464, "Charles De Ketelaere", "AMF"],
      [80465, "Albert Gudmundsson", "AMF"],
      [80466, "Valentin Gimenez", "CF"],
      [80467, "Remo Freuler", "CMF"],
      [80468, "Nikola Vlasic", "AMF"],
      [80469, "M Simakan", "CB"],
      [80470, "Julian Weigl", "DMF"],
      [80471, "Julian Ryerson", "RB"],
      [80472, "Christoph Baumgartner", "AMF"],
      [80473, "Mario Gtze", "AMF"],
      [80474, "Robin Koch", "CB"],
      [80475, "Angelo Stiller", "DMF"],
      [80476, "Franck Honorat", "RW"],
      [80477, "Philipp Lienhart", "CB"],
      [80478, "Nadiem Amiri", "CMF"],
      [80479, "Frederik Rnnow", "GK"],
      [80480, "Nemanja Matic", "DMF"],
      [80481, "Wilfried Singo", "RB"],
      [80482, "Marco Bizot", "GK"],
      [80483, "Lucas Perri", "GK"],
      [80485, "Leonardo Balerdi", "CB"],
      [80486, "Geoffrey Kondogbia", "DMF"],
      [80487, "Amine Gouiri", "CF"],
      [80488, "Denis Zakaria", "DMF"],
      [80489, "Takumi Minamino", "LW"],
      [80490, "Valentin Rongier", "CMF"],
      [80491, "Yehvann Diouf", "GK"],
      [80492, "Pierre Melou", "DMF"],
      [80493, "Santiago Gimenez", "CF"],
      [80494, "Jerdy Schouten", "DMF"],
      [80495, "Quinten Timber", "CMF"],
      [80496, "Olivier Boscagli", "CB"],
      [80497, "Walter Benitez", "GK"],
      [80498, "Johan Bakayoko", "RW"],
      [80499, "Jordy Clasie", "DMF"],
      [80500, "Alexander Bah", "RB"],
      [80501, "Galeno", "LW"],
      [80502, "Kerem Akturkolu", "LW"],
      [80503, "Filip Kosti", "LMF"],
      [80504, "Alvaro Just", "CMF"],
      [80505, "Hugo Lloris", "GK"],
      [80506, "Emil Forsberg", "LW"],
      [80507, "Edson Alvarez", "DMF"],
      [80508, "Joe Gomez", "CB"],
      [80509, "D Kamada", "AMF"],
      [80510, "David Lopez", "CB"],
      [80511, "Nuno Santos", "LB"],
      [80512, "Paul Pogba", "CMF"],
      [80513, "Samuele Ricci", "DMF"],
      [80514, "Mason Mount", "AMF"],
      [80515, "Nicolas Gonzalez", "RW"],
      [80516, "Christian Nrgaard", "DMF"],
      [80517, "Alejandro Ferreyra", "LW"],
      [80518, "Ousmane Diomande", "CB"],
      [80519, "Aleksandar Pavlovic", "DMF"],
      [80520, "Pau Cubarsi", "CB"],
      [80522, "Dan Burn", "CB"],
      [80523, "Joan Jordan", "CMF"],
      [80524, "Khephren Thuram-Ulien", "CMF"],
      [80525, "Edon Zhegrova", "RW"],
      [80526, "Corentin Tolisso", "CMF"],
      [80527, "Nicolas Tagliafico", "LB"],
      [80528, "Senne Lammens", "GK"],
      [80529, "Leny Yoro", "CB"],
      [80530, "Nicolas Iglesias", "CMF"],
      [80531, "James Trafford", "GK"],
      [80532, "Abdukodir Khusanov", "CB"],
      [80533, "Raul Asencio", "CB"],
      [80534, "Raoul Bellanova", "RMF"],
      [80592, "Jose Tasende", "LB"],
      [80618, "Goncalo Ramos", "CF"],
      [80649, "Jorrel Hato", "LB"],
      [80650, "Tom Bischof", "CMF"],
      [80666, "Jacob Ramsey", "CMF"],
      [80785, "Anthony Elanga", "RW"],
      [80794, "Mikkel Damsgaard", "AMF"],
      [80795, "Caoimhin Kelleher", "GK"],
      [80884, "Gauthier Hein", "RW"],
      [80535, "Presnel Kimpembe", "CB"],
      [80536, "Mauro Icardi", "CF"],
      [80537, "Rasmus Hojlund", "CF"],
      [80538, "Leon Butler", "RW"],
      [80539, "Mario Lemina", "DMF"],
      [80540, "Wilfred Ndidi", "DMF"],
      [80541, "Chukwunonso Madueke", "RW"],
      [80542, "Curtis Jones", "CMF"],
      [80543, "Pape Sarr", "CMF"],
      [80544, "Brennan Johnson", "RW"],
      [80545, "Yves Bissouma", "DMF"],
      [80546, "Valentino Livramento", "RB"],
      [80547, "Callum Hudson-Odoi", "LW"],
      [80548, "Tyrone Mings", "CB"],
      [80549, "Matty Cash", "RB"],
      [80550, "Lewis Dunk", "CB"],
      [80551, "Tyrick Mitchell", "LB"],
      [80552, "Jefferson Lerma", "DMF"],
      [80553, "Ethan Pinnock", "CB"],
      [80554, "Enes Unal", "CF"],
      [80555, "Antoine Semenyo", "RW"],
      [80556, "Lewis Cook", "CMF"],
      [80557, "Max Kilman", "CB"],
      [80558, "Vitaliy Mykolenko", "LB"],
      [80559, "Joao Da Silva", "CMF"],
      [80560, "Jose Sa", "GK"],
      [80561, "Matt O'Riley", "CMF"],
      [80562, "Jonathan Ikone", "RW"],
      [80563, "Diego Carlos", "CB"],
      [80564, "Yeremi Pino", "RW"],
      [80565, "Omar Alderete", "CB"],
      [80566, "Reinildo Mandava", "LB"],
      [80567, "Francisco Torres", "LB"],
      [80568, "Yuri Berchiche", "LB"],
      [80569, "Gorka Rodriguez", "CF"],
      [80570, "Diego Llorente", "CB"],
      [80571, "Marc Bartra", "CB"],
      [80572, "Hugo Perales", "CF"],
      [80573, "Cesar Azpilicueta", "CB"],
      [80574, "Marko Dmitrovic", "GK"],
      [80575, "Ruben Garcia", "RW"],
      [80576, "Antonio Raillo", "CB"],
      [80577, "Diego Rico", "LB"],
      [80578, "Luis Milla", "CMF"],
      [80579, "Mauro Arambarri", "CMF"],
      [80581, "Weston McKennie", "CMF"],
      [80582, "Pietro Terracciano", "GK"],
      [80583, "Sam Beukema", "CB"],
      [80584, "Leonardo Spinazzola", "LB"],
      [80585, "Mathias Olivera", "LB"],
      [80586, "Odilon Kossounou", "CB"],
      [80587, "Davide Zappacosta", "RMF"],
      [80588, "Berat Djimsiti", "CB"],
      [80589, "Isak Hien", "CB"],
      [80591, "Stephan El Shaarawy", "LW"],
      [80593, "Dodo", "RB"],
      [80594, "Manuel Lazzari", "RMF"],
      [80595, "Nicolo Rovella", "DMF"],
      [80596, "Adam Marusic", "RB"],
      [80597, "Lewis Ferguson", "CMF"],
      [80598, "Lukasz Skorupski", "GK"],
      [80599, "Cristiano Biraghi", "LB"],
      [80601, "Enzo Le Fee", "CMF"],
      [80602, "Anton Stach", "DMF"],
      [80603, "Nordi Mukiele", "RB"],
      [80604, "Andre Silva", "CF"],
      [80605, "Karim-David Adeyemi", "RW"],
      [80606, "Castello Lukeba", "CB"],
      [80607, "Xaver Schlager", "CMF"],
      [80608, "Lukas Klostermann", "CB"],
      [80609, "Chris Fuhrich", "LW"],
      [80610, "Mitchell Weiser", "RB"],
      [80611, "Tim Kleindienst", "CF"],
      [80612, "Jonas Omlin", "GK"],
      [80613, "Wilfried Zaha", "LW"],
      [80614, "Arnaud Kalimuendo", "CF"],
      [80615, "Adrien Truffert", "LB"],
      [80616, "Bafode Diakite", "CB"],
      [80617, "Mathew Ryan", "GK"],
      [80619, "Caio Silva", "LB"],
      [80620, "Vanderson Campos", "RB"],
      [80621, "Ludovic Blas", "RW"],
      [80622, "Przemyslaw Frankowski", "RB"],
      [80623, "Dante", "CB"],
      [80624, "Melvin Bard", "LB"],
      [80625, "Jonathan Gradit", "CB"],
      [80626, "Romain Del Castillo", "RW"],
      [80627, "Anthony Lopes", "GK"],
      [80628, "Josip Utalo", "CB"],
      [80629, "Steven Berghuis", "RW"],
      [80630, "Brian Brobbey", "CF"],
      [80631, "Sheraldo Becker", "LW"],
      [80632, "Hidemasa Morita", "CMF"],
      [80633, "Bruma", "LW"],
      [80634, "Anatoliy Trubin", "GK"],
      [80635, "Joao Mario", "LW"],
      [80636, "Fabio Vieira", "AMF"],
      [80637, "Georginio Wijnaldum", "CMF"],
      [80638, "Stefan Savic", "CB"],
      [80639, "Dominik Livakovic", "GK"],
      [80640, "Arkadiusz Milik", "CF"],
      [80641, "Thomas Lemar", "AMF"],
      [80642, "Yann Bisseck", "CB"],
      [80643, "Yunus Musah", "CMF"],
      [80644, "Lorenzo Lucca", "CF"],
      [80645, "Tammy Abraham", "CF"],
      [80646, "Strahinja Pavlovic", "CB"],
      [80647, "Jamie Gittens", "LW"],
      [80648, "Samuel Aghehowa", "CF"],
      [80651, "Hector Garcia", "RB"],
      [80652, "W Endo", "DMF"],
      [80653, "Wesley Fofana", "CB"],
      [80654, "Amad Diallo", "RW"],
      [80655, "Clinton Mata", "CB"],
      [80656, "Lewis Hall", "LB"],
      [80657, "Kalvin Phillips", "DMF"],
      [80658, "Liam Delap", "CF"],
      [80659, "Ethan Nwaneri", "AMF"],
      [80667, "Oleksandr Zinchenko", "LB"],
      [80728, "Giacomo Raspadori", "AMF"],
      [80906, "Georgiy Sudakov", "AMF"],
      [80912, "Jakub Kiwior", "CB"],
      [81045, "Facundo Buonanotte", "AMF"],
      [81320, "Omari Hutchinson", "AMF"],
      [80691, "Eric Garcia", "CB"],
      [80727, "Malick Thiaw", "CB"],
      [80826, "Oscar Mingueza", "RB"],
      [80933, "Fermin Lopez", "AMF"],
      [81073, "Clement Lenglet", "CB"],
      [80661, "Nelson Semedo", "RB"],
      [80662, "Trevoh Chalobah", "CB"],
      [80663, "Axel Disasi", "CB"],
      [80664, "Oluwatosin Adarabioyo", "CB"],
      [80665, "Jacob Murphy", "RW"],
      [80668, "Christopher Wood", "CF"],
      [80669, "Amadou Onana", "DMF"],
      [80670, "Ian Maatsen", "LB"],
      [80671, "Jan Van Hecke", "CB"],
      [80672, "Adam Wharton", "DMF"],
      [80673, "Cheick Doucoure", "DMF"],
      [80674, "Maxence Lacroix", "CB"],
      [80675, "Ismala Sarr", "RW"],
      [80676, "Nathan Collins", "CB"],
      [80677, "Sepp Van Den Berg", "CB"],
      [80678, "Callum Wilson", "CF"],
      [80679, "Konstantinos Mavropanos", "CB"],
      [80680, "Dwight McNeil", "LW"],
      [80681, "Idrissa Gueye", "DMF"],
      [80682, "Emmanuel Agbadou", "CB"],
      [80683, "Alex Moreno", "LB"],
      [80684, "Emerson", "LB"],
      [80685, "Ben Chilwell", "LB"],
      [80687, "Sebastien Haller", "CF"],
      [80688, "Jasper Cillessen", "GK"],
      [80689, "Cristhian Ibarguen", "CB"],
      [80690, "Ladislav Krejci", "CB"],
      [80692, "Aritz Elustondo", "CB"],
      [80693, "Alberto Gonzalez", "LW"],
      [80694, "Luiz Junior", "GK"],
      [80695, "Chimy Avila", "CF"],
      [80696, "Marc Junque", "DMF"],
      [80697, "Pau Lopez", "GK"],
      [80698, "Domingos Almeida", "AMF"],
      [80699, "Fran Beltran", "CMF"],
      [80700, "Borja Iglesias", "CF"],
      [80701, "Djibril Sow", "CMF"],
      [80702, "Javier Diaz", "LW"],
      [80703, "Jon Moncayola", "CMF"],
      [80704, "Lucas Torro", "DMF"],
      [80705, "Martin Valjent", "CB"],
      [80706, "Augusto Batalla", "GK"],
      [80707, "Borja Mayoral", "CF"],
      [80708, "Loc Bade", "CB"],
      [80709, "Francisco Conceicao", "RW"],
      [80710, "Andrea Cambiaso", "LB"],
      [80711, "Gianluca Scamacca", "CF"],
      [80713, "Rolando Mandragora", "DMF"],
      [80714, "Mario Fuentes", "CB"],
      [80715, "Matias Vecino", "CMF"],
      [80716, "Jhon Bonilla", "CB"],
      [80717, "Nicolo Casale", "CB"],
      [80718, "Juan Miranda", "LB"],
      [80719, "Maxence Caqueret", "CMF"],
      [80720, "Stefan Posch", "CB"],
      [80721, "Guillermo Maripan", "CB"],
      [80722, "Morten Frendrup", "CMF"],
      [80723, "Yerry Mina", "CB"],
      [80724, "Sebastiano Luperto", "CB"],
      [80725, "Lorenzo Montipo", "GK"],
      [80726, "Federico Baschirotto", "CB"],
      [80729, "Robin Gosens", "LB"],
      [80730, "Lutsharel Geertruida", "RB"],
      [80731, "Sacha Boey", "RB"],
      [80732, "Maximilian Beier", "CF"],
      [80733, "Jonathan Burkardt", "CF"],
      [80734, "Julian Chabot", "CB"],
      [80735, "Andreas Olsen", "RW"],
      [80736, "Christian Gunter", "LB"],
      [80737, "Jae-Sung Lee", "AMF"],
      [80738, "Felix Nmecha", "CMF"],
      [80739, "M'Bala Nzola", "CF"],
      [80740, "Said Benrahma", "LW"],
      [80741, "Dilane Bakwa", "RW"],
      [80742, "Benjamin Lecomte", "GK"],
      [80743, "Thilo Kehrer", "CB"],
      [80744, "Maghnes Akliouche", "RW"],
      [80745, "Alexsandro Ribeiro", "CB"],
      [80746, "Mahdi Camara", "CMF"],
      [80747, "Hicham Boudaoui", "CMF"],
      [80748, "Moses Simon", "LW"],
      [80749, "Ruben Aguilar", "RB"],
      [80750, "Florian Sotoca", "CF"],
      [80751, "Brendan Chardonnet", "CB"],
      [80752, "Kenny Lala", "RB"],
      [80753, "Guillaume Restes", "GK"],
      [80754, "Nick Olij", "GK"],
      [80755, "Sergio Dest", "RB"],
      [80756, "Ismael El Basra", "CMF"],
      [80757, "Mauro Junior", "LB"],
      [80758, "Gernot Trauner", "CB"],
      [80759, "Hirving Lozano", "LW"],
      [80760, "Daniel Bragana", "CMF"],
      [80761, "Rodrigo Martinez", "CMF"],
      [80762, "Joao Moutinho", "CMF"],
      [80763, "Alexander Djiku", "CB"],
      [80764, "Marcus Edwards", "RW"],
      [80765, "Manor Solomon", "LW"],
      [80766, "Armand Lauriente", "LW"],
      [80767, "Marco Reus", "AMF"],
      [80768, "Alvaro Rosa", "GK"],
      [80769, "Joachim Andersen", "CB"],
      [80770, "Moi Gomez", "LW"],
      [80771, "Emil Audero", "GK"],
      [80772, "Lamine Camara", "CMF"],
      [80773, "Mateus Fernandes", "CMF"],
      [80774, "Eliesse Seghir", "LW"],
      [80775, "El Diouf", "LB"],
      [80776, "Sidi Bane", "CB"],
      [80777, "Carlos Soler", "CMF"],
      [80778, "Moussa Niakhate", "CB"],
      [80779, "Malick Fofana", "LW"],
      [80780, "Estevo", "RW"],
      [80781, "Myles Lewis-Skelly", "LB"],
      [80782, "Eli Kroupi", "CF"],
      [80908, "Franco Mastantuono", "RW"],
      [81021, "Mykhailo Mudryk", "LW"],
      [81044, "Yoan Bonny", "CF"],
      [81054, "Tyler Dibling", "RW"],
      [81150, "Borja Eguskiza", "LW"],
      [81192, "Martin Baturina", "AMF"],
      [80783, "Konstantinos Tsimikas", "LB"],
      [80784, "Benoit Badiashile", "CB"],
      [80786, "Elliott Anderson", "CMF"],
      [80787, "Nicolas Dominguez", "CMF"],
      [80788, "Neco Williams", "LB"],
      [80789, "Morgan Rogers", "AMF"],
      [80790, "Harvey Elliott", "AMF"],
      [80791, "Ross Barkley", "CMF"],
      [80792, "Danny Welbeck", "CF"],
      [80793, "Bart Verbruggen", "GK"],
      [80796, "Marcos Senesi", "CB"],
      [80797, "Ryan Christie", "CMF"],
      [80798, "Marcus Tavernier", "LMF"],
      [80799, "Tyler Adams", "DMF"],
      [80800, "Igor", "CB"],
      [80801, "Kyle Walker-Peters", "RB"],
      [80802, "Mads Hermansen", "GK"],
      [80803, "Mark Travers", "GK"],
      [80804, "Norberto Betuncal", "CF"],
      [80805, "Timothy Castagne", "RB"],
      [80806, "Calvin Ughelumba", "CB"],
      [80807, "Kenny Tete", "RB"],
      [80808, "Emile Rowe", "AMF"],
      [80809, "Sam Johnstone", "GK"],
      [80810, "Tote Gomes", "CB"],
      [80811, "Hwang Chan", "CF"],
      [80812, "Martin Dubravka", "GK"],
      [80813, "Bilal El Khannouss", "AMF"],
      [80814, "Vladimir Coufal", "RB"],
      [80815, "Joao Cardoso", "CMF"],
      [80816, "Pablo Rivas", "CMF"],
      [80817, "Aitor Casamichana", "CB"],
      [80818, "Santi Comesaa", "CMF"],
      [80819, "Sergi Bermudez", "LB"],
      [80820, "Alfonso Pedraza", "LB"],
      [80821, "Rodrigo Reche", "LW"],
      [80822, "Pablo Fornals", "CMF"],
      [80823, "Julen Agirrezabala", "GK"],
      [80824, "Thierry Correia", "RB"],
      [80825, "Stole Dimitrievski", "GK"],
      [80827, "Aimar Huarte", "AMF"],
      [80828, "Johan Mojica", "LB"],
      [80829, "Alfonso Espino", "LB"],
      [80830, "Jorge Sebastian", "RW"],
      [80831, "Facundo Tenaglia", "RB"],
      [80832, "Nikola Krstovi", "CF"],
      [80834, "Gustav Isaksen", "RW"],
      [80835, "Danilo Cataldi", "DMF"],
      [80836, "Saul Oubia", "CB"],
      [80837, "Enrico Delprato", "RB"],
      [80838, "Nicolo Zaniolo", "AMF"],
      [80839, "Ruslan Malinovskyi", "AMF"],
      [80840, "Dan Ndoye", "RW"],
      [80841, "Noah Okafor", "LW"],
      [80842, "Saud Abdulhamid", "RB"],
      [80843, "Yacine Adli", "DMF"],
      [80844, "Emiliano Buendia", "AMF"],
      [80845, "Ridle Baku", "RB"],
      [80846, "Sepe Wahi", "CF"],
      [80847, "Mergim Berisha", "CF"],
      [80848, "Jan-Niklas Beste", "RW"],
      [80849, "Arthur Theate", "CB"],
      [80850, "Rasmus Kristensen", "RB"],
      [80851, "Vincent Sierro", "CMF"],
      [80852, "Romain Faivre", "RMF"],
      [80853, "Georges Mikautadze", "CF"],
      [80854, "Arnau Urea", "GK"],
      [80855, "Matvey Safonov", "GK"],
      [80856, "Jordan Teze", "RB"],
      [80857, "Thomas Meunier", "RB"],
      [80858, "Tiago Santos", "RB"],
      [80859, "Assa Mandi", "CB"],
      [80860, "Nabil Bentaleb", "DMF"],
      [80861, "Breel Embolo", "CF"],
      [80862, "Hans Hateboer", "RB"],
      [80863, "Lilian Brassier", "CB"],
      [80864, "Youssouf Ndayishimiye", "CB"],
      [80865, "Jeremie Boga", "LW"],
      [80866, "Adrien Thomasson", "AMF"],
      [80867, "Radosaw Majecki", "GK"],
      [80868, "Ryan Flamingo", "CB"],
      [80869, "Guus Til", "AMF"],
      [80870, "Timon Wellenreuther", "GK"],
      [80871, "Philippe Sandler", "CB"],
      [80872, "Tobias Lauritsen", "CF"],
      [80873, "Bertrand Traore", "RW"],
      [80874, "Andrea Belotti", "CF"],
      [80875, "Matheus Reis", "LB"],
      [80876, "Eduardo Quaresma", "CB"],
      [80877, "Zeno Debast", "CB"],
      [80878, "Geny Catamo", "RW"],
      [80879, "Tomas Araujo", "CB"],
      [80880, "Sikou Niakate", "CB"],
      [80881, "Alan Varela", "DMF"],
      [80882, "Marvin Schwbe", "GK"],
      [80883, "Nicolas Kuhn", "RW"],
      [80885, "Perr Schuurs", "CB"],
      [80886, "Hany Mukhtar", "AMF"],
      [80887, "Mbemba", "CB"],
      [80888, "Miguel Almiron", "RW"],
      [80890, "Solly March", "RW"],
      [80892, "Unai Nuez", "CB"],
      [80893, "Jonathan Bamba", "LW"],
      [80894, "Ricardo Rodriguez", "LB"],
      [80895, "Juanmi", "LW"],
      [80896, "Giorgio Scalvini", "CB"],
      [80897, "Ivan Ilic", "CMF"],
      [80898, "Suat Serdar", "CMF"],
      [80899, "Angel Gomes", "AMF"],
      [80900, "Calvin Stengs", "AMF"],
      [80901, "Jeremiah St Juste", "CB"],
      [80902, "Tommaso Pobega", "CMF"],
      [80903, "Koni De Winter", "CB"],
      [80904, "Ilias Chakkour", "RW"],
      [80905, "Semeu Commey", "CB"],
      [80907, "Endrick", "CF"],
      [80909, "Jamie Vardy", "CF"],
      [80910, "Lennon Miller", "CMF"],
      [81072, "Simon Adingra", "LW"],
      [81243, "Fabio Silva", "CF"],
      [80911, "Arijanet Muric", "GK"],
      [80913, "Ben Davies", "CB"],
      [80914, "Joe Willock", "CMF"],
      [80915, "Joao Silva", "RW"],
      [80916, "Ola Aina", "RB"],
      [80917, "Ibrahim Sangare", "DMF"],
      [80918, "Joel Veltman", "RB"],
      [80919, "Christopher Richards", "CB"],
      [80920, "Vitaly Janelt", "DMF"],
      [80921, "Mathias Jensen", "CMF"],
      [80922, "Justin Kluivert", "AMF"],
      [80923, "Iliman Ndiaye", "LW"],
      [80924, "Harry Wilson", "RW"],
      [80925, "Issa Diop", "CB"],
      [80926, "Sander Berge", "DMF"],
      [80927, "Sasa Lukic", "CMF"],
      [80928, "Marshall Munetsi", "CMF"],
      [80929, "Santiago Sciutto", "CB"],
      [80930, "Jrgen Larsen", "CF"],
      [80931, "Yukinari Sugawara", "RB"],
      [80932, "Orel Mangala", "DMF"],
      [80934, "Beat Diaz", "CMF"],
      [80935, "Andoni Gorosabel", "RB"],
      [80936, "Mikel Vesga", "DMF"],
      [80937, "Sergio Martin", "LB"],
      [80938, "Pape Gueye", "DMF"],
      [80939, "Hector Bellerin", "RB"],
      [80940, "Diego Noguerol", "RW"],
      [80941, "Arnaut Danjuma", "LW"],
      [80942, "Luis Rioja", "LW"],
      [80943, "Dani Raba", "AMF"],
      [80944, "Mouctar Diakhaby", "CB"],
      [80945, "Bryan Martinez", "LW"],
      [80946, "Chidera Ejuke", "LW"],
      [80947, "Rjan Nyland", "GK"],
      [80948, "Marcos Teixeira", "CB"],
      [80949, "Leandro Cabrera", "CB"],
      [80950, "Kike Garcia", "CF"],
      [80951, "Marash Kumbulla", "CB"],
      [80952, "Ivan Campeny", "RB"],
      [80953, "Antonio Sivera", "GK"],
      [80954, "Adria Pedrosa", "LB"],
      [80955, "Josep Riera", "GK"],
      [80956, "Zeki Celik", "RB"],
      [80957, "Luca Ranieri", "CB"],
      [80958, "Christian Kouame", "CF"],
      [80959, "Pablo Mari", "CB"],
      [80960, "Samuel Gigot", "CB"],
      [80961, "Alberto Moreno", "LB"],
      [80962, "Lucas Da Cunha", "CMF"],
      [80963, "Che Adams", "CF"],
      [80964, "Hernani", "CMF"],
      [80965, "Adrian Garcia", "CMF"],
      [80966, "Stefano Turati", "GK"],
      [80967, "Johan Vasquez", "CB"],
      [80968, "Michel Aebischer", "CMF"],
      [80969, "Antonio Sanabria", "CF"],
      [80970, "Jaka Bijol", "CB"],
      [80971, "Sofyan Amrabat", "DMF"],
      [80972, "Romano Schmid", "AMF"],
      [80973, "Luis Henrique", "RMF"],
      [80974, "Neil El Aynaoui", "CMF"],
      [80975, "Ismail Jakobs", "LB"],
      [80976, "Evann Guessand", "CF"],
      [80977, "Baptiste Santamaria", "DMF"],
      [80978, "Azzedine Ounahi", "CMF"],
      [80979, "Mathias Lage", "LW"],
      [80980, "Amine Harit", "AMF"],
      [80981, "Hamed Traore", "LW"],
      [80982, "Mohammed Salisu", "CB"],
      [80983, "Philipp Khn", "GK"],
      [80984, "Folarin Balogun", "CF"],
      [80985, "Hakon Haraldsson", "AMF"],
      [80986, "Quentin Merlin", "LB"],
      [80987, "Tanguy Ndombele", "CMF"],
      [80988, "Sofiane Diop", "LW"],
      [80989, "Morgan Sanson", "CMF"],
      [80990, "Ainsley Maitland-Niles", "RB"],
      [80991, "Deiver Mena", "LB"],
      [80992, "Ludovic Ajorque", "CF"],
      [80993, "Cristian Yepes", "CMF"],
      [80994, "Rasmus Nicolaisen", "CB"],
      [80995, "Yann Gboho", "LW"],
      [80996, "Almoatasembellah Al Musrati", "DMF"],
      [80997, "Daniele Rugani", "CB"],
      [80998, "Kenneth Taylor", "CMF"],
      [80999, "Mike Van Der Hoorn", "CB"],
      [81000, "Souffian El Karouani", "LB"],
      [81001, "Quilindschy Hartman", "LB"],
      [81002, "Calvin Verdonk", "LB"],
      [81003, "In-Beom Hwang", "DMF"],
      [81004, "Stephen Eustaquio", "CMF"],
      [81005, "Paulo Oliveira", "CB"],
      [81006, "Victor Perea", "RB"],
      [81007, "Leonardo Lelo", "LB"],
      [81008, "Jobson Gonzaga", "CB"],
      [81009, "Zaydou Youssouf", "CMF"],
      [81010, "Bruno Varela", "GK"],
      [81011, "Toni Borevkovic", "CB"],
      [81012, "Maxi Araujo", "LMF"],
      [81013, "Kerem Demirbay", "CMF"],
      [81014, "Joe Rodon", "CB"],
      [81015, "Maxime Esteve", "CB"],
      [81016, "Maxime Lopez", "DMF"],
      [81017, "Janis Blaswich", "GK"],
      [81018, "Adam Webster", "CB"],
      [81019, "Jack Harrison", "LW"],
      [81020, "Goncalo Guedes", "LW"],
      [81022, "Inigo Lekue", "RB"],
      [81023, "Aitor Garcia", "RB"],
      [81024, "Cristhian Curbelo", "CF"],
      [81025, "Joseph Aidoo", "CB"],
      [81026, "Oscar Luengo", "CMF"],
      [81027, "Rafa Mir", "CF"],
      [81028, "Djene", "CB"],
      [81030, "Nicola Zalewski", "LMF"],
      [81031, "Marco Sportiello", "GK"],
      [81032, "Fabiano Parisi", "LB"],
      [81033, "Patric", "CB"],
      [81034, "Arthur Vermeeren", "DMF"],
      [81035, "Mario Hermoso", "CB"],
      [81036, "Terem Moffi", "CF"],
      [81037, "Branco Van Den Boomen", "CMF"],
      [81038, "Joao Mario", "RB"],
      [81039, "Leandro Martins", "CMF"],
      [81040, "Umar Mesbah", "CF"],
      [81041, "Oscar Trejo", "AMF"],
      [81042, "Marcos Almeida", "CF"],
      [81043, "Elseid Hysaj", "RB"],
      [81046, "Assane Diaoune", "LW"],
      [81047, "Mika Godts", "LW"],
      [81048, "Franjo Ivanovi", "CF"],
      [81049, "Degnand Gnonto", "RW"],
      [81050, "Bryan Gil", "LW"],
      [81051, "Cucho Hernandez", "CF"],
      [81052, "Stefanos Tzimas", "CF"],
      [81053, "Nathan Zeze", "CB"],
      [81055, "Jan Bednarek", "CB"],
      [81056, "Andrew Ventura", "GK"],
      [81057, "Abdoulaye Doucoure", "AMF"],
      [81058, "Ryan Yates", "CMF"],
      [81059, "Georginio Rutter", "CF"],
      [81060, "Jason Steele", "GK"],
      [81061, "Yankuba Minteh", "RW"],
      [81062, "Eddie Nketiah", "CF"],
      [81063, "Kristoffer Ajer", "CB"],
      [81064, "Dango Ouattara", "LW"],
      [81065, "Crysencio Summerville", "LW"],
      [81066, "James Garner", "DMF"],
      [81067, "Jake O'Brien", "CB"],
      [81068, "Michael Keane", "CB"],
      [81069, "Raul Jimenez", "CF"],
      [81070, "Adama Traore", "RW"],
      [81071, "James Justin", "RB"],
      [81074, "Logan Costa", "CB"],
      [81075, "Javier Moreno", "CMF"],
      [81076, "Jose Copete", "CB"],
      [81077, "Carl Starfelt", "CB"],
      [81078, "Omar El Hilali", "RB"],
      [81079, "Valentin Rosier", "RB"],
      [81080, "Samuel Costa", "DMF"],
      [81081, "Omar Gonzalez", "DMF"],
      [81082, "Andrei Raiu", "RB"],
      [81083, "Javier Jimenez", "CMF"],
      [81084, "Juan Sanchez", "RB"],
      [81085, "Albert Lokonga", "CMF"],
      [81086, "Lazar Samardi", "AMF"],
      [81087, "Pierluigi Gollini", "GK"],
      [81088, "Tommaso Baldanzi", "AMF"],
      [81089, "Nuno Tavares", "LB"],
      [81090, "Luca Pellegrini", "LB"],
      [81091, "Thijs Dallinga", "CF"],
      [81092, "Nikola Moro", "DMF"],
      [81093, "Kristjan Asllani", "DMF"],
      [81094, "Patrick Cutrone", "CF"],
      [81095, "Andrea Pinamonti", "CF"],
      [81096, "Maduka Okoye", "GK"],
      [81097, "Aaron Caricol", "LB"],
      [81099, "Marco Silvestri", "GK"],
      [81100, "Frederic Guilbert", "RB"],
      [81101, "Antonino Gallo", "LB"],
      [81102, "Dennis Man", "RW"],
      [81103, "Ondrej Duda", "CMF"],
      [81104, "Borna Sosa", "LB"],
      [81105, "Florian Thauvin", "AMF"],
      [81106, "Manu Kone", "CMF"],
      [81107, "Mahmoud Dahoud", "CMF"],
      [81108, "Marco Friedl", "CB"],
      [81109, "Nico Elvedi", "CB"],
      [81110, "Alassane Plea", "CF"],
      [81111, "Ko Itakura", "CB"],
      [81112, "Jonas Wind", "CF"],
      [81113, "Joakim Maehle", "LB"],
      [81114, "Jens Stage", "CMF"],
      [81115, "Zakaria Aboukhlal", "RW"],
      [81116, "Pablo Rosario", "DMF"],
      [81117, "Christopher Operi", "LB"],
      [81118, "Duje Caleta-Car", "CB"],
      [81119, "Gabriel Urbina", "LB"],
      [81120, "Aurelio Buta", "RB"],
      [81121, "Lorenz Assignon", "RB"],
      [81122, "Michael Bermudez", "RB"],
      [81123, "Sebastian Nanasi", "LMF"],
      [81124, "Alidu Seidu", "CB"],
      [81125, "Hugo Magnetti", "CMF"],
      [81126, "Joris Chotard", "DMF"],
      [81127, "Mark McKenzie", "CB"],
      [81128, "Charlie Cresswell", "CB"],
      [81129, "Aron Dnnum", "LMF"],
      [81130, "Mostafa Abdallah", "CF"],
      [81131, "Donovan Leon", "GK"],
      [81132, "Gautier Lloris", "CB"],
      [81133, "Himad Abdelli", "AMF"],
      [81134, "Davy Klaassen", "CMF"],
      [81135, "Vasilis Barkas", "GK"],
      [81136, "Dirk Proper", "DMF"],
      [81137, "Roger Fernandes", "RW"],
      [81138, "Vitor Vieira", "DMF"],
      [81139, "Gustavo Sa", "AMF"],
      [81140, "Marios Vrousai", "RB"],
      [81141, "Gabriel De Souza", "GK"],
      [81142, "Gabriel Vieira", "RW"],
      [81143, "Joel Robles", "GK"],
      [81145, "Tiago Esgaio", "RB"],
      [81146, "Felix Correia", "LW"],
      [81147, "Joel Piroe", "CF"],
      [81148, "Jaidon Anthony", "LW"],
      [81149, "Leander Dendoncker", "DMF"],
      [81151, "Gabri Veiga", "AMF"],
      [81152, "Daniel James", "RW"],
      [81153, "Jayden Bogle", "RB"],
      [81154, "Ao Tanaka", "CMF"],
      [81155, "Josh Cullen", "DMF"],
      [81156, "Junior Firpo", "LB"],
      [81157, "Saa Kalajdi", "CF"],
      [81158, "Paul Onuachu", "CF"],
      [81159, "Willy Boly", "CB"],
      [81160, "Felipe Da Silva", "CB"],
      [81161, "Igor Thiago", "CF"],
      [81162, "Rodrigo Carvalho", "CF"],
      [81163, "Jean-Ricner Bellegarde", "CMF"],
      [81164, "Sean Longstaff", "CMF"],
      [81165, "Cyle Larin", "CF"],
      [81166, "Portu", "RW"],
      [81167, "Abel Ortega", "CF"],
      [81168, "Franco Cervi", "LW"],
      [81169, "Dani Rodriguez", "AMF"],
      [81170, "Ander Guevara", "CMF"],
      [81171, "Marin Pongrai", "CB"],
      [81172, "Nicolo Fagioli", "CMF"],
      [81173, "Adrien Tameze", "DMF"],
      [81174, "Mandela Keita", "DMF"],
      [81175, "Vitor Oliveira", "CF"],
      [81176, "Riccardo Sottil", "LW"],
      [81177, "Angelo Fulgini", "AMF"],
      [81178, "Bradley Locko", "LB"],
      [81179, "Steven Bergwijn", "LW"],
      [81180, "Franco Israel", "GK"],
      [81181, "Tiago Djalo", "CB"],
      [81182, "Josip Brekalo", "LW"],
      [81183, "Rico Henry", "LB"],
      [81184, "Justin Bijlow", "GK"],
      [81185, "Jose Figueiredo", "CB"],
      [81186, "Julio Espinola", "AMF"],
      [81187, "Alessandro Circati", "CB"],
      [81188, "Diego Moreira", "LMF"],
      [81189, "Kristian Hlynsson", "AMF"],
      [81190, "Petar Sui", "DMF"],
      [81191, "Carney Chukwuemeka", "CMF"],
      [81193, "Sem Steijn", "AMF"],
      [81194, "Samu", "AMF"],
      [81195, "Otavio Da Silva", "CB"],
      [81196, "Odsonne Edouard", "CF"],
      [81197, "Dominik Greif", "GK"],
      [81198, "Ernest Nuamah", "RW"],
      [81199, "Romeo Lavia", "DMF"],
      [81200, "Martin Satriano", "CF"],
      [81201, "Pavel Sulc", "AMF"],
      [81202, "Stefan Maquieira", "DMF"],
      [81203, "Giovanni Leoni", "CB"],
      [81204, "Daniele Padelli", "GK"],
      [81205, "Archie Gray", "DMF"],
      [81206, "Jimenez", "RB"],
      [81207, "Jack Hinshelwood", "DMF"],
      [81208, "Billy Gilmour", "DMF"],
      [81209, "Conor Bradley", "RB"],
      [81210, "Radu Dragusin", "CB"],
      [81211, "Will Hughes", "CMF"],
      [81212, "Keane Lewis-Potter", "LW"],
      [81213, "Kevin Schade", "LW"],
      [81214, "Tom Cairney", "CMF"],
      [81215, "Matt Doherty", "RB"],
      [81216, "Jesper Lindstrm", "RW"],
      [81217, "Sergio Poirrier", "CB"],
      [81218, "Jesus Areso", "RB"],
      [81219, "Arsen Zakharyan", "AMF"],
      [81220, "Ander Barrenetxea", "LW"],
      [81221, "Luka Sucic", "CMF"],
      [81222, "Nicolas Pepe", "RW"],
      [81223, "Diego Alcolado", "GK"],
      [81224, "Bernardo De Souza", "CB"],
      [81225, "Abdessamad Ezzalzouli", "LW"],
      [81226, "Lucas Beltran", "AMF"],
      [81227, "Dimitri Foulquier", "RB"],
      [81228, "Jose Navarro", "RB"],
      [81229, "Enrique Valiente", "CB"],
      [81230, "Eduardo Jaen", "CMF"],
      [81231, "Pablo Carral", "AMF"],
      [81232, "Manuel Ario", "CMF"],
      [81233, "Pathe Ciss", "CMF"],
      [81234, "Unai Lopez", "CMF"],
      [81235, "Denis Suarez", "AMF"],
      [81236, "Jon Guridi", "CMF"],
      [81237, "Antonio Conde", "DMF"],
      [81238, "Toni Martinez", "CF"],
      [81239, "Ignacio Sotorres", "GK"],
      [81240, "Domingos Duarte", "CB"],
      [81241, "Kiko Femenia", "RB"],
      [81242, "Manu Sanchez", "LB"],
      [81244, "Alex Kral", "CMF"],
      [81245, "Fabio Miretti", "CMF"],
      [81246, "Juan Jesus", "CB"],
      [81247, "Edoardo Bove", "CMF"],
      [81248, "Tijjani Noslin", "RW"],
      [81249, "Christos Mandas", "GK"],
      [81250, "Nicolo Cambiaghi", "LW"],
      [81251, "Emil Holm", "RB"],
      [81252, "Santiago Castro", "CF"],
      [81253, "Marc-Oliver Kempf", "CB"],
      [81254, "Alberto Dossena", "CB"],
      [81255, "Emanuele Valeri", "LB"],
      [81256, "Zion Suzuki", "GK"],
      [81257, "Hassane Kamara", "LB"],
      [81258, "Sandi Lovric", "CMF"],
      [81259, "Junior Messias", "RW"],
      [81260, "Simone Scuffet", "GK"],
      [81261, "Sebastiano Esposito", "AMF"],
      [81262, "Elia Caprile", "GK"],
      [81263, "Tomas Suslov", "AMF"],
      [81264, "Lassana Coulibaly", "CMF"],
      [81265, "Jose Oliva", "LW"],
      [81266, "Nehuen Perez", "CB"],
      [81267, "Jackson Tchatchoua", "RB"],
      [81268, "Matteo Ruggeri", "LB"],
      [81269, "Timothy Weah", "RW"],
      [81270, "Eljif Elmas", "LW"],
      [81271, "Oumar Solet", "CB"],
      [81272, "Chrislain Matsima", "CB"],
      [81273, "Hugo Larsson", "CMF"],
      [81274, "Josip Stanisic", "RB"],
      [81275, "K Kampl", "CMF"],
      [81276, "Nicolas Seiwald", "CMF"],
      [81277, "Patrick Wimmer", "RW"],
      [81278, "Adam Hlozek", "AMF"],
      [81279, "Andy Diouf", "CMF"],
      [81280, "Joao Rodrigues", "CF"],
      [81281, "Gabriel Gudmundsson", "LB"],
      [81282, "Mouhamadou Diarra", "CMF"],
      [81283, "Guela Doue", "RB"],
      [81284, "Osame Sahraoui", "LW"],
      [81285, "Mousa Al-Tamari", "RW"],
      [81286, "Christopher Wooh", "CB"],
      [81287, "Mohamed-Ali Cho", "RW"],
      [81288, "Wesley Said", "CF"],
      [81289, "Abdallah Sima", "LW"],
      [81290, "Sinaly Diomande", "CB"],
      [81291, "Abdoulaye Toure", "DMF"],
      [81292, "Herve Koffi", "GK"],
      [81293, "Ricardo Pepi", "CF"],
      [81294, "Thomas Beelen", "CB"],
      [81295, "Ayase Ueda", "CF"],
      [81296, "Nick Viergever", "CB"],
      [81297, "Ramiz Zerrouki", "DMF"],
      [81298, "Joris Kramer", "CB"],
      [81299, "P Aaronson", "AMF"],
      [81300, "Francisco Moura", "LB"],
      [81301, "Clayton Silva", "CF"],
      [81302, "Rodrigo Barros", "CB"],
      [81303, "David Simo", "CMF"],
      [81304, "Sylla Morlaye", "LW"],
      [81305, "Tiago Gouveia", "RW"],
      [81306, "Zian Flemming", "CF"],
      [81307, "Tsuyoshi Watanabe", "CB"],
      [81308, "Kasper Dolberg", "CF"],
      [81309, "Pascal Struijk", "CB"],
      [81310, "Ethan Ampadu", "CB"],
      [81311, "Trai Hume", "RB"],
      [81312, "Ilan Kebbal", "AMF"],
      [81313, "Matthieu Udol", "LB"],
      [81314, "Aleksey Miranchuk", "AMF"],
      [81315, "Aaron Hickey", "RB"],
      [81316, "Lloyd Kelly", "CB"],
      [81317, "Tariq Lamptey", "RB"],
      [81318, "Tyrell Malacia", "LB"],
      [81319, "Altay Bayndr", "GK"],
      [81321, "Taiwo Awoniyi", "CF"],
      [81322, "James Milner", "CMF"],
      [81323, "Alvaro Odriozola", "RB"],
      [81324, "Cedric Bakambu", "CF"],
      [81325, "Enrique Afonso", "RW"],
      [81326, "Juan Armada", "LB"],
      [81327, "Eric Bailly", "CB"],
      [81328, "Romain Perraud", "LB"],
      [81329, "Giovanni Fabbian", "AMF"],
      [81330, "Maxwel Cornet", "LW"],
      [81331, "Hyeon-Seok Hong", "AMF"],
      [81332, "Amine Adli", "LW"],
      [81333, "Lovro Majer", "AMF"],
      [81334, "Kevin Stger", "AMF"],
      [81335, "David Da Costa", "AMF"],
      [81336, "Massadio Haidara", "LB"],
      [81337, "Warmed Omari", "CB"],
      [81338, "Neal Maupay", "CF"],
      [81339, "Krepin Diatta", "RW"],
      [81340, "Glen Kamara", "CMF"],
      [81341, "Seko Fofana", "CMF"],
      [81342, "Bart Nieuwkoop", "RB"],
      [81343, "Francisco Aliaga", "CF"],
      [81344, "Aderllan Santos", "CB"],
      [81345, "Michael Folorunsho", "CMF"],
      [81346, "Wout Weghorst", "CF"],
      [81347, "Luciano Valente", "AMF"],
      [81348, "Jakob Breum", "AMF"],
      [81349, "Sven Mijnans", "AMF"],
      [81350, "Ricky Van Wolfswinkel", "CF"],
      [81351, "Mees Hilgers", "CB"],
      [81352, "Sam Lammers", "CF"],
      [81353, "Matthew Turner", "GK"],
      [81354, "Ondej Lingr", "AMF"],
      [81355, "Odysseas Vlachodimos", "GK"],
      [81356, "Maxime Dupe", "GK"],
      [81357, "Fotis Ioannidis", "CF"],
      [81358, "David Carmo", "CB"],
      [81359, "Abner Santos", "LB"],
      [81360, "Tyler Morton", "DMF"],
      [81361, "Marcus Bettinelli", "GK"],
      [81362, "Gonzalo Garcia", "CF"],
      [81363, "Remko Pasveer", "GK"],
      [81364, "Bram Nuytinck", "CB"],
      [81365, "Ivan Corraliza", "RB"],
      [81366, "Christopher Trimmel", "RB"],
      [81367, "Evan Ferguson", "CF"],
      [81368, "Renan Ribeiro", "GK"],
      [81369, "Benjamin Stambouli", "DMF"],
      [81370, "Mamadou Sarr", "CB"],
      [81371, "Jeremy Jacquet", "CB"],
      [81372, "Badredine Bouanani", "RW"],
      [81373, "Noah Sadiki", "CMF"],
      [81374, "Regis Gurtner", "GK"],
      [81375, "Arthur Avom", "CMF"],
      [81376, "Tiago Cardoso", "GK"],
      [80660, "Stefan Moreno", "GK"],
      [80686, "Raul Albiol", "CB"],
      [80833, "Pedro", "RW"],
      [80889, "Victor Lindelof", "CB"],
      [81029, "Ansu Fati", "LW"],
      [81098, "Juan Cuadrado", "RMF"],
      [81377, "Jhon Palacio", "CF"],
      [81378, "Brajan Gruda", "RW"],
      [81379, "David Brooks", "RW"],
      [81380, "Alex Scott", "CMF"],
      [81381, "Ryan Sessegnon", "LB"],
      [81382, "Gustavo Dos Santos", "RB"],
      [81383, "Luis Maqueda", "RB"],
      [81384, "Dario Essugo", "DMF"],
      [81385, "Giuliano Baldini", "RW"],
      [81386, "Aihen Munoz", "LB"],
      [81387, "Cesar Requeni", "CB"],
      [81388, "Ilaix Moriba", "CMF"],
      [81389, "Flavien-Enzo Boyomo", "CB"],
      [81390, "Takuma Asano", "RW"],
      [81391, "Carlos Robles", "RW"],
      [81392, "Leo Roman", "GK"],
      [81393, "Juan Murillo", "LB"],
      [81394, "Charalampos Lykogiannis", "LB"],
      [81395, "Jens Odgaard", "AMF"],
      [81396, "Tasos Douvikas", "CF"],
      [81397, "Valentino Lazaro", "RMF"],
      [81398, "Adam Masina", "CB"],
      [81399, "Ardian Ismajli", "CB"],
      [81400, "Nicola Leali", "GK"],
      [81401, "Lorenzo Colombo", "CF"],
      [81402, "Karol Linetty", "CMF"],
      [81403, "Diego Coppola", "CB"],
      [81404, "Ionut Radu", "GK"],
      [81405, "Gift Orban", "CF"],
      [81408, "Frank Onyeka", "CMF"],
      [81409, "Valentin Gendrey", "RB"],
      [81410, "A Nusa", "LW"],
      [81411, "Kamil Grabara", "GK"],
      [81412, "Mattias Svanberg", "CMF"],
      [81413, "Modibo Sagnan", "CB"],
      [81414, "Ismael Doukoure", "CB"],
      [81415, "Kamory Doumbia", "AMF"],
      [81416, "Djibril Sidibe", "RB"],
      [81417, "Nicolas Cozza", "LB"],
      [81418, "Matthis Abline", "CF"],
      [81419, "Johann Lepenant", "DMF"],
      [81420, "Kelvin Amian", "RB"],
      [81421, "Lassine Sinayoko", "CF"],
      [81422, "Loc Nego", "RB"],
      [81423, "Jordan Lefort", "CB"],
      [81424, "Gijs Smal", "LB"],
      [81425, "Mike Eerdhuijzen", "CB"],
      [81426, "Siebe Horemans", "RB"],
      [81427, "Victor Edvardsen", "CF"],
      [81428, "Joshua Kitolano", "CMF"],
      [81429, "Mattijs Branderhorst", "GK"],
      [81430, "Stijn Van Gassel", "GK"],
      [81431, "David Wolfe", "LB"],
      [81432, "Samuel Soares", "GK"],
      [81433, "Justin De Haas", "CB"],
      [81434, "Oscar Subiela", "LW"],
      [81435, "Frederico Venancio", "CB"],
      [81436, "Kewin Silva", "GK"],
      [81437, "Enea Mihaj", "CB"],
      [81438, "Abdelhamid Sabiri", "AMF"],
      [81439, "Charles Vanhoutte", "DMF"],
      [81440, "Laurent Abergel", "DMF"],
      [81441, "Miro Muheim", "LB"],
      [81442, "Jamaal Lascelles", "CB"],
      [81443, "Fabio Carvalho", "AMF"],
      [81444, "Seamus Coleman", "RB"],
      [81445, "Jarell Quansah", "CB"],
      [81446, "Ivan Jaime", "AMF"],
      [81447, "Alejandro Torrijo", "RB"],
      [81448, "Ivan Martinez", "GK"],
      [81449, "Tanguy-Austin Kouassi", "CB"],
      [81450, "Adnan Januzaj", "RW"],
      [81451, "Ramon Espacio", "CMF"],
      [81452, "Raul De Haro", "CF"],
      [81453, "Toni Lato", "LB"],
      [81454, "Sergio Perez", "CF"],
      [81455, "Zito Luvumbo", "CF"],
      [81456, "Gianluca Gaetano", "AMF"],
      [81457, "Antoine Makoumbou", "DMF"],
      [81458, "Arnaud Nordin", "RW"],
      [81459, "Daniel Svensson", "LB"],
      [81460, "Andreas Hanche-Olsen", "CB"],
      [81461, "Faris Moumbagna", "CF"],
      [81462, "Oussama Targhalline", "DMF"],
      [81463, "Anthony Rouault", "CB"],
      [81464, "Andries Noppert", "GK"],
      [81465, "Riechedly Bazoer", "CB"],
      [81466, "Zaidu", "LB"],
      [81467, "Rochinha", "LW"],
      [81468, "Joao Saraiva", "AMF"],
      [81469, "Federico Ceccherini", "CB"],
      [81470, "Maximilian Wber", "CB"],
      [81471, "Harrison Reed", "CMF"],
      [81472, "Nacho Vidal", "RB"],
      [81473, "T Buchanan", "RW"],
      [81474, "Michy Batshuayi", "CF"],
      [81475, "Jordan Lotomba", "RB"],
      [81476, "Salis Samed", "DMF"],
      [81477, "Daan Rots", "RW"],
      [81478, "Bas Kuipers", "LB"],
      [81479, "Jason", "RW"],
      [81480, "Jeffrey De Lange", "GK"],
      [81481, "Emanuel Emegha", "CF"],
      [81482, "Oscar Gloukh", "AMF"],
      [81483, "Yvon Mvogo", "GK"],
      [81484, "Tanner Tessmann", "DMF"],
      [80580, "Mattia Perin", "GK"],
      [80891, "Dominic Calvert-Lewin", "CF"],
      [81144, "Jose Fonte", "CB"],
      [81485, "Djed Spence", "LB"],
      [81486, "Lesley Ugochukwu", "DMF"],
      [81488, "Raul Moro", "LW"],
      [81489, "Enzo Barrenechea", "DMF"],
      [81490, "Santiago Mourio", "CB"],
      [81491, "Yaser Martinez", "RW"],
      [81492, "Juan Velasco", "RB"],
      [81493, "Lucien Agoume", "DMF"],
      [81494, "Abdul Mumin", "CB"],
      [81495, "Josep Perez", "LB"],
      [81496, "Yvan Neyou", "DMF"],
      [81497, "Abdelkabir Abqar", "CB"],
      [81498, "Amir Richardson", "CMF"],
      [81499, "Mattia Viti", "CB"],
      [81500, "Simon Sohm", "CMF"],
      [81501, "Roberto Piccoli", "CF"],
      [81502, "Edoardo Goldaniga", "CB"],
      [81503, "Maximo Perrone", "DMF"],
      [81504, "Alieu Fadera", "LW"],
      [81505, "Jurgen Ekkelenkamp", "CMF"],
      [81506, "Kingsley Ehizibue", "RB"],
      [81507, "Jesper Karlstrm", "DMF"],
      [81508, "Luca Mazzitelli", "CMF"],
      [81509, "Gabriele Zappa", "RB"],
      [81510, "Giuseppe Pezzella", "LB"],
      [81511, "Casper Tengstedt", "CF"],
      [81512, "Ferro", "CB"],
      [81513, "Charles", "GK"],
      [81514, "Valentin Mihil", "LW"],
      [81515, "Konstantinos Koulierakis", "CB"],
      [81516, "Phillipp Mwene", "LB"],
      [81517, "Jakic", "DMF"],
      [81518, "Jackson Irvine", "CMF"],
      [81519, "Abdoulaye Ndiaye", "CB"],
      [81520, "Ki-Jana Hoever", "RB"],
      [81521, "Leo Petrot", "LB"],
      [81522, "Felix Lemarechal", "AMF"],
      [81523, "Julien Le Cardinal", "CB"],
      [81524, "Josue Casimir", "RW"],
      [81525, "Elisha Owusu", "DMF"],
      [81526, "Gideon Mensah", "LB"],
      [81527, "Yassine Kechta", "CMF"],
      [81528, "Etienne Kinkoue", "CB"],
      [81529, "Youri Regeer", "CMF"],
      [81530, "Rome-Jayden Owusu-Oduro", "GK"],
      [81531, "Troy Parrott", "CF"],
      [81532, "Michael Brouwer", "GK"],
      [81533, "Miguel Vidal", "RW"],
      [81534, "Ringo Meerveld", "AMF"],
      [81535, "Pawel Bochniewicz", "CB"],
      [81536, "Oskar Zawada", "CF"],
      [81537, "Etienne Vaessen", "GK"],
      [81538, "Ivo Pinto", "RB"],
      [81539, "Loreintz Rosier", "DMF"],
      [81540, "Hugo Lopez", "LB"],
      [81541, "Robin Roefs", "GK"],
      [81542, "Rafa Soares", "LB"],
      [81543, "Gaizka Goikoetxea", "RB"],
      [81544, "Joao Goncalves", "GK"],
      [81545, "Godfried Frimpong", "LB"],
      [81546, "Martim Fernandes", "RB"],
      [81547, "Sorriso", "RW"],
      [81548, "Stefan Mitrovi", "LW"],
      [81549, "Daniel Boloca", "DMF"],
      [81550, "Matteo Tramoni", "AMF"],
      [81551, "Anel Ahmedhodi", "CB"],
      [81552, "Brenden Aaronson", "AMF"],
      [81553, "Berke Zer", "GK"],
      [81554, "Jean-Philippe Krasso", "CF"],
      [81555, "Kevin Diks", "RB"],
      [81556, "Toma Basic", "CMF"],
      [81557, "Ruben Blanco", "GK"],
      [81558, "Nathaniel Clyne", "RB"],
      [81559, "Adam Smith", "RB"],
      [81560, "Julian Araujo", "RB"],
      [81561, "Daniel Bentley", "GK"],
      [81562, "Axel Tuanzebe", "RB"],
      [81563, "Mamadou Diallo", "CF"],
      [81564, "Robert Munoz", "RW"],
      [81565, "Donny Van De Beek", "CMF"],
      [81566, "Akor Adams", "CF"],
      [81567, "Isaac Bernal", "CF"],
      [81568, "Fernando Calero", "CB"],
      [81569, "Antonio Sanchez", "CMF"],
      [81570, "Gerard Gumbau", "DMF"],
      [81571, "Devyne Rensch", "RB"],
      [81572, "Matteo Cancellieri", "RW"],
      [81573, "Marcus Pedersen", "RMF"],
      [81574, "Alessandro Zanoli", "RB"],
      [81575, "Morten Thorsby", "CMF"],
      [81576, "Abdou Harroui", "CMF"],
      [81577, "Grigoris Kastanos", "AMF"],
      [81578, "Youssef Maleh", "CMF"],
      [81579, "Eldor Shomurodov", "CF"],
      [81580, "Yahia Fofana", "GK"],
      [81581, "Lautaro Giannetti", "CB"],
      [81582, "Leo Stigard", "CB"],
      [81583, "Matej Kovar", "GK"],
      [81584, "Jamie Leweling", "RW"],
      [81585, "Marco Grull", "LW"],
      [81586, "Josip Juranovic", "RB"],
      [81587, "Yussuf Poulsen", "CF"],
      [81588, "Roland Sallai", "RB"],
      [81589, "Soungoutou Magassa", "DMF"],
      [81590, "Ulisses Garcia", "LB"],
      [81591, "Christian Mawissa", "CB"],
      [81592, "Thibault De Smet", "LB"],
      [81593, "Mathieu Cafaro", "RW"],
      [81594, "Frank Magri", "CF"],
      [81595, "Junior Mwanga", "DMF"],
      [81596, "Arouna Sangante", "CB"],
      [81597, "Andre Gomes", "CMF"],
      [81598, "Seba Perez", "DMF"],
      [81599, "Francisco Tome", "LW"],
      [81600, "Jorge Fernandes", "CB"],
      [81601, "Ricardo Esgaio", "RB"],
      [81602, "D Ramaj", "GK"],
      [81603, "Batista Mendy", "DMF"],
      [81604, "Florian Kainz", "AMF"],
      [81605, "Albert Grnbk", "AMF"],
      [81606, "Armel Kotchap", "CB"],
      [81607, "Wilson Odobert", "LW"],
      [81608, "Jorge Cuenca", "CB"],
      [81609, "Armando Broja", "CF"],
      [81610, "Sergi Gomez", "CB"],
      [81611, "Eray Cmert", "CB"],
      [81612, "Pere Milla", "LW"],
      [81613, "Abdon Bastidas", "CF"],
      [81614, "Francisco Martinez", "RW"],
      [81615, "Carles Alea", "CMF"],
      [81616, "Iker Aragunde", "AMF"],
      [81617, "Valentin Barco", "CMF"],
      [81618, "Giovanni Simeone", "CF"],
      [81619, "Saba Sazonov", "CB"],
      [81620, "Cyril Ngonge", "RW"],
      [81621, "Victor Nelsson", "CB"],
      [81622, "Gauthier Gallon", "GK"],
      [81623, "Reda Khadra", "AMF"],
      [81624, "Armando Obispo", "CB"],
      [81625, "Owen Wijndal", "LB"],
      [81626, "Rafik Guitane", "RW"],
      [81627, "Ricardo Batista", "GK"],
      [81628, "Mohamed Amdouni", "CF"],
      [81629, "Reiss Nelson", "LW"],
      [81630, "Mama Balde", "CF"],
      [81631, "Andre Franco", "AMF"],
      [81632, "Rob Holding", "CB"],
      [81633, "Kaio Lima", "RW"],
      [81634, "Juma Bah", "CB"],
      [81635, "Ibou Sane", "CF"],
      [81636, "Guilherme Montoia", "LB"],
      [81637, "Kialonda Gaspar", "CB"],
      [81638, "Alan Guimaraes", "AMF"],
      [81639, "Antonin Kinsky", "GK"],
      [81640, "Louis Beyer", "CB"],
      [81641, "Lucas Boye", "CF"],
      [81642, "Oscar Bobb", "RW"],
      [81643, "Nico O'Reilly", "CMF"],
      [82806, "Atanas Chernev", "DMF"],
      [81487, "Rafael Fernandes", "CB"],
      [81644, "Carlos Alcaraz", "CMF"],
      [81645, "Pelle Clement", "CMF"],
      [81646, "Thierno Barry", "CF"],
      [81647, "Unai Larraaga", "GK"],
      [81648, "Sergio Clavell", "CMF"],
      [81649, "Adrian", "GK"],
      [81650, "Carlos Serrano", "LB"],
      [81651, "Abel Cruz", "LB"],
      [81652, "Daniele Ghilardi", "CB"],
      [81653, "Nadir Zortea", "RB"],
      [81654, "Lorenzo De Silvestri", "RB"],
      [81655, "Ignace Van Der Brempt", "RB"],
      [81656, "Cesare Casadei", "CMF"],
      [81657, "Alberto Paleari", "GK"],
      [81658, "Gaetano Oristanio", "AMF"],
      [81659, "Jay Idzes", "CB"],
      [81660, "Christian Kabasele", "CB"],
      [81661, "Rzvan Sava", "GK"],
      [81662, "Stefano Sabelli", "RB"],
      [81663, "Daniel Mosquera", "CF"],
      [81664, "Alberto Grassi", "DMF"],
      [81665, "Ylber Ramadani", "DMF"],
      [81666, "Pedro Pereira", "RB"],
      [81667, "Nicolas Valentini", "CB"],
      [81668, "Josha Vagnoman", "RB"],
      [81669, "Denis Vavro", "CB"],
      [81670, "Alexander Prass", "LB"],
      [81671, "Joe Scally", "RB"],
      [81672, "Dimitrios Giannoulis", "LB"],
      [81673, "Cedric Zesiger", "CB"],
      [81674, "Ali Abdi", "LB"],
      [81675, "Jhoanner Chavez", "LB"],
      [81676, "Florent Hanin", "LB"],
      [81677, "Ezequiel Bullaude", "AMF"],
      [81678, "Yoann Cathline", "LW"],
      [81679, "Dylan Vente", "CF"],
      [81680, "Sam Kersten", "CB"],
      [81681, "K Ogawa", "CF"],
      [81682, "Mats Deijl", "RB"],
      [81683, "Jasper Schendelaar", "GK"],
      [81684, "Anselmo Macnulty", "CB"],
      [81685, "Simon Graves", "CB"],
      [81686, "Mitchell Van Bergen", "RW"],
      [81687, "Stije Resink", "DMF"],
      [81688, "Ivan Alvarez", "CB"],
      [81689, "Alen Halilovi", "AMF"],
      [81690, "Leo Greiml", "CB"],
      [81691, "Max Balard", "DMF"],
      [81692, "Geovany Quenda", "RW"],
      [81693, "Bright Arrey-Mbi", "CB"],
      [81694, "Joao Marques", "LW"],
      [81695, "Robson De Barros", "CB"],
      [81696, "Adrian Marin", "LB"],
      [81697, "Vinicius Lopes", "CF"],
      [81698, "Ui-Jo Hwang", "CF"],
      [81699, "Dan Neil", "CMF"],
      [81700, "Lucas Silva", "LB"],
      [81701, "Jonny Otto", "RB"],
      [81702, "Jeremy Toljan", "RB"],
      [81703, "Moustapha Mbow", "CB"],
      [81704, "Cheikh Sabaly", "LW"],
      [81705, "Wes Foderingham", "GK"],
      [81706, "Juan Corral", "GK"],
      [81707, "Yerson Mosquera", "CB"],
      [81708, "Rodrigo Gomes", "RB"],
      [81709, "Lucas Rosa", "RB"],
      [81710, "Unai Etxebarria", "AMF"],
      [81711, "Jofre Pages", "RW"],
      [81712, "Pol Vizuete", "CMF"],
      [81713, "Pedro Fanjul", "CMF"],
      [81714, "Pasquale Mazzocchi", "RB"],
      [81715, "Fisayo Dele-Bashiru", "AMF"],
      [81716, "Benjamin Dominguez", "LW"],
      [81717, "Mrgim Vojvoda", "RB"],
      [81718, "Nahuel Estevez", "DMF"],
      [81719, "Sebastian Walukiewicz", "CB"],
      [81720, "Oier Egaa", "CMF"],
      [81721, "Thomas Kristensen", "CB"],
      [81722, "Keinan Davis", "CF"],
      [81723, "Brenner Da Silva", "CF"],
      [81724, "Yannik Engelhardt", "DMF"],
      [81725, "Merlin Rhl", "AMF"],
      [81726, "Andras Schfer", "CMF"],
      [81727, "Jonathan Rowe", "LW"],
      [81728, "Ismael Kone", "CMF"],
      [81729, "Woyo Coulibaly", "RB"],
      [81730, "Valentin Carboni", "AMF"],
      [81731, "Ignatius Ganago", "CF"],
      [81732, "Tanguy Coulibaly", "LW"],
      [81733, "A Sylla", "CB"],
      [81734, "Soumaila Coulibaly", "CB"],
      [81735, "Malang Sarr", "CB"],
      [81736, "Niklas Schmidt", "CMF"],
      [81737, "Cheikh Dieng", "CF"],
      [81738, "Abdoulaye Bamba", "CB"],
      [81739, "Jim Allevinah", "RW"],
      [81740, "Mathias Kjl", "DMF"],
      [81741, "Ahmetcan Kaplan", "CB"],
      [81742, "Lucas De Almeida", "RB"],
      [81743, "Alejandro Mendez", "CF"],
      [81744, "Nelson Oliveira", "CF"],
      [81745, "Nuno Santos", "AMF"],
      [81746, "Lawrence Ofori", "CMF"],
      [81747, "Guven Yaln", "CF"],
      [81748, "Jutgla", "CF"],
      [81749, "Harry Toffolo", "LB"],
      [81750, "Lewis Miley", "CMF"],
      [81751, "Emil Krafth", "RB"],
      [81752, "Chadi Dnanou", "CB"],
      [81753, "Daley Sinkgraven", "LB"],
      [81754, "Mihailo Risti", "LB"],
      [81755, "Mitchel Bakker", "LB"],
      [81756, "Adrian Benedyczak", "LW"],
      [81757, "Walid Cheddira", "CF"],
      [81758, "Matteo Prati", "DMF"],
      [81759, "Lameck Banda", "LW"],
      [81760, "Mateusz Wieteska", "CB"],
      [81761, "Lucas Tousart", "CMF"],
      [81762, "Gabriel De Salles", "DMF"],
      [81763, "Mohamed Bayo", "CF"],
      [81764, "Luiz Felipe", "CB"],
      [81765, "Francis Coquelin", "DMF"],
      [81766, "Andreas Schjelderup", "LW"],
      [81767, "Jakub Moder", "CMF"],
      [81768, "Francisco Oliveira", "LW"],
      [81769, "Renato Veiga", "CB"],
      [81770, "Giovanni Reyna", "AMF"],
      [81771, "Abdoul Meite", "CB"],
      [81772, "Braydon Manu", "RW"],
      [81773, "Joel Drommel", "GK"],
      [81774, "Serdar Saat", "CB"],
      [81775, "Claudio Ramos", "GK"],
      [81776, "Matias Fernandez-Pardo", "LW"],
      [81777, "Oliver Braude", "RB"],
      [81778, "Marc Torras", "DMF"],
      [81779, "Sadibou Sane", "CB"],
      [81780, "Niccolo Fortini", "LB"],
      [81781, "Marco Sala", "LB"],
      [81782, "Christian Fruchtl", "GK"],
      [81783, "Jeroen Zoet", "GK"],
      [81784, "Seiya Maikuma", "RB"],
      [81785, "Taylor Booth", "RW"],
      [81786, "Arno Verschueren", "AMF"],
      [81787, "Sayfallah Ltaief", "LW"],
      [81788, "Joao Virginia", "GK"],
      [81789, "Miguel Magalhes", "RB"],
      [81790, "Kiki", "LB"],
      [81791, "Nikola Maras", "CB"],
      [81792, "Kristian Thorstvedt", "AMF"],
      [81793, "Kevin De Macedo", "LW"],
      [81794, "Filip Ugrinic", "CMF"],
      [81795, "Vladyslav Vanat", "CF"],
      [81796, "Jose Morales", "CF"],
      [81797, "Unai Vencedor", "CMF"],
      [81798, "Silas Katompa-Mvumpa", "RW"],
      [81799, "Patrick Van Aanholt", "LB"],
      [81800, "Pizzi", "AMF"],
      [81801, "Murilo Costa", "RW"],
      [82804, "Paulo Moreira", "CMF"],
      [82820, "Guus Offerhaus", "CB"],
      [81802, "Williot Swedberg", "LW"],
      [81803, "Carlos Caceres", "CB"],
      [81804, "Sergio Vilario", "RB"],
      [81805, "Christantus Uche", "CF"],
      [81806, "Daniel Maldini", "AMF"],
      [81807, "Devis Vasquez", "GK"],
      [81808, "Jacopo Fazzini", "CMF"],
      [81809, "Federico Ravaglia", "GK"],
      [81810, "Botond Balogh", "CB"],
      [81811, "Lautaro Valenti", "CB"],
      [81812, "Domagoj Bradaric", "LB"],
      [81813, "Martin Payero", "CMF"],
      [81814, "Sael Nseke", "RB"],
      [81815, "Sadou Sow", "CB"],
      [81816, "Warren Kamanzi", "RB"],
      [81817, "Issa Soumare", "LW"],
      [81818, "Haris Belkebla", "CMF"],
      [81819, "Anis Hadj-Moussa", "RW"],
      [81820, "Youri Baas", "CB"],
      [81821, "Kian Fitz-Jim", "CMF"],
      [81822, "Luuk Brouwers", "AMF"],
      [81823, "Nordin Bakker", "GK"],
      [81824, "Vasilis Zagaritis", "LB"],
      [81825, "Roberto Bayon", "RW"],
      [81826, "Kodai Sano", "CMF"],
      [81827, "Sherel Floranus", "RB"],
      [81828, "Julian Baas", "CMF"],
      [81829, "Marco Rente", "RB"],
      [81830, "Shawn Adewoye", "CB"],
      [81831, "Damon Mirani", "CB"],
      [81832, "Yassin Oukili", "CMF"],
      [81833, "Tom Van De Looi", "DMF"],
      [81834, "Felix Bacher", "CB"],
      [81835, "Pedro Amaral", "LB"],
      [81836, "Patrick Sequeira", "GK"],
      [81837, "Duplexe Tchamba", "CB"],
      [81838, "Nico Mantl", "GK"],
      [81839, "Alfonso Hernandez", "RW"],
      [81840, "Guilherme Guimaraes", "CF"],
      [81841, "Rodrigo Pinho", "CF"],
      [81842, "Antonio Mendes", "CF"],
      [81843, "Cristian Devenish", "CB"],
      [81844, "Wagner De Pina", "RB"],
      [81845, "Mihajlo Ili", "CB"],
      [81846, "Nilton Lopes", "LB"],
      [81847, "Gustavo Rodrigues", "LW"],
      [81848, "Jacob Ondrejka", "LW"],
      [81849, "Adrian Semper", "GK"],
      [81850, "Michele Collocolo", "CMF"],
      [81851, "Robin Propper", "CB"],
      [81852, "Georgios Vagiannidis", "RB"],
      [81853, "Jesurun Rak-Sakyi", "RW"],
      [81854, "Ilia Gruev", "DMF"],
      [81855, "Salomon Rondon", "CF"],
      [81856, "Horaiu Moldovan", "GK"],
      [81857, "Hamza Igamane", "CF"],
      [81858, "Montassar Talbi", "CB"],
      [81859, "Darlin Ngameni", "LB"],
      [81860, "Habib Diallo", "CF"],
      [81861, "Carlo Pinsoglio", "GK"],
      [81862, "Omar Richards", "LB"],
      [81863, "Samuel Lima", "GK"],
      [81864, "Valentin Gomez", "CB"],
      [81865, "Kamaldeen Sulemana", "LW"],
      [81866, "Michael Kayode", "RB"],
      [81867, "Randy Nteka", "AMF"],
      [81868, "Moussa Diarra", "CB"],
      [81869, "Carlos Protesoni", "DMF"],
      [81870, "Pablo Lumbreras", "CMF"],
      [81871, "Jon Dozagarat", "CB"],
      [81872, "Javi Lopez", "LB"],
      [81873, "Milan Uri", "CF"],
      [81874, "Caleb Ekuban", "CF"],
      [81875, "Alessandro Deiola", "CMF"],
      [81876, "Leonardo Pavoletti", "CF"],
      [81877, "Martin Frese", "LB"],
      [81878, "Enzo Ebosse", "CB"],
      [81879, "Mohamed Kaba", "CMF"],
      [81880, "Rafael Zamora", "CB"],
      [81881, "Fabian Rieder", "AMF"],
      [81882, "Leopold Querfeld", "CB"],
      [81883, "Robert Skov", "LMF"],
      [81884, "Emmanuel Sabbi", "RW"],
      [81885, "Pol Lirola", "RB"],
      [81886, "George Ilenikhena", "CF"],
      [81887, "Andrew Omobamidele", "CB"],
      [81888, "Jean-Kevin Duverne", "CB"],
      [81889, "Fabien Centonze", "RB"],
      [81890, "Rassoul Ndiaye", "DMF"],
      [81891, "Pierrick Capelle", "CMF"],
      [81892, "Adamo Nagalo", "CB"],
      [81893, "Jens Toornstra", "AMF"],
      [81894, "Samuel Bastien", "CMF"],
      [81895, "Manuel Silva", "DMF"],
      [81896, "Joao Novais", "CMF"],
      [81897, "Jonathan Panzo", "CB"],
      [81898, "Ole Pohlmann", "AMF"],
      [81899, "Tiago Morais", "LW"],
      [81900, "Jose Goncalves", "RB"],
      [81901, "Boris Popovi", "CB"],
      [81902, "Fabio Conceicao", "RW"],
      [81903, "Martim Neto", "CMF"],
      [81904, "Daniel Loader", "CF"],
      [81905, "David Okereke", "CF"],
      [81906, "James McAtee", "AMF"],
      [81907, "Luis Dos Santos", "RW"],
      [81908, "Juan Gonzalez", "CB"],
      [81909, "Jesus Alcalde", "LB"],
      [81910, "Cenk Zkaar", "CB"],
      [81911, "Ibrahim Sulemana", "DMF"],
      [81912, "Mattia Valoti", "CMF"],
      [81913, "Filippo Terracciano", "RB"],
      [81914, "Loum Tchaouna", "RW"],
      [81915, "Oussama El Azzouzi", "DMF"],
      [81916, "Aster Vranckx", "CMF"],
      [81917, "Sebastiaan Bornauw", "CB"],
      [81918, "Fode Ballo-Toure", "LB"],
      [81919, "Couhaib Driouech", "LW"],
      [81920, "Goncalo Borges", "RW"],
      [81921, "Lincoln Dos Santos", "AMF"],
      [81922, "Mateu Bauza", "RB"],
      [81923, "Ruben Vargas", "LW"],
      [81924, "Eduard Sobol", "LB"],
      [81925, "Alejandro Romero", "GK"],
      [81926, "Marvin Senaya", "RB"],
      [81927, "Thomas Delaine", "LB"],
      [81928, "Kaj Sierhuis", "CF"],
      [81929, "David Fofana", "CF"],
      [81930, "Yasin Ayari", "CMF"],
      [81931, "Yarek Gsiorowski", "CB"],
      [81932, "Ben Doak", "RW"],
      [81933, "Demir Tknaz", "DMF"],
      [81934, "Niek Schiks", "GK"],
      [81935, "Iker Horcajo", "RW"],
      [81936, "Ruben Van Bommel", "LW"],
      [81937, "Ibrahim Sadiq", "RW"],
      [81938, "Wouter Goes", "CB"],
      [81939, "Peer Koopmeiners", "DMF"],
      [81940, "Bart Van Rooij", "RB"],
      [81941, "Jonathan De Guzman", "CMF"],
      [81942, "Mayckel Lahdo", "RW"],
      [81943, "Martin Vitik", "CB"],
      [81944, "Oliver Sorensen", "CMF"],
      [81945, "Adam Buksa", "CF"],
      [81946, "Alexandre Penetra", "CB"],
      [81947, "Andres Robledo", "RB"],
      [81948, "Mike Ndayishimiye", "LW"],
      [81949, "David Affengruber", "CB"],
      [81950, "Marc Aguado", "DMF"],
      [81951, "Federico Redondo", "DMF"],
      [81952, "Alex Sancris", "RW"],
      [81953, "Carlos Alvarez", "RW"],
      [81954, "Federico Vias", "CF"],
      [81955, "Santiago Colombatto", "DMF"],
      [81956, "Youssef El Arabi", "CF"],
      [81957, "Xeka", "CMF"],
      [81958, "Marcos Lopes", "RW"],
      [81959, "Mikel Alboniga", "CMF"],
      [81960, "Remy Descamps", "GK"],
      [81961, "Joshua Wilson-Esbrand", "LB"],
      [82807, "Gonzalo Sanchidrian", "CF"],
      [82815, "Jaylan Van Schooneveld", "CB"],
      [82828, "Adil Lechkar", "RB"],
      [81962, "Vitezslav Jaros", "GK"],
      [81963, "Pablo De Jesus", "CF"],
      [81964, "Jon Mejias", "RB"],
      [81965, "Hans Caviglia", "CMF"],
      [81966, "Adam Obert", "CB"],
      [81967, "Amin Sarr", "CF"],
      [81968, "Morgan Guilavogui", "RW"],
      [81969, "Woo-Yeong Jeong", "AMF"],
      [81970, "Manolis Saliakas", "RB"],
      [81971, "Theoson-Jordan Siebatcheu", "CF"],
      [81972, "Mose Bombito", "CB"],
      [81973, "Antoine Mendy", "RB"],
      [81974, "Carlens Arcus", "RB"],
      [81975, "Anton Gaaei", "RB"],
      [81976, "Dave Van Den Berg", "CMF"],
      [81977, "Gerrit Nauber", "CB"],
      [81978, "Marvin Peersman", "CB"],
      [81979, "Daniel Bielica", "GK"],
      [81980, "Fabian De Keijzer", "GK"],
      [81981, "Jizz Hornkamp", "CF"],
      [81982, "Oscar Fraulo", "CMF"],
      [81983, "Thomas Ouwejan", "LB"],
      [81984, "Mohamed Ihattaren", "AMF"],
      [81985, "Rodrigo De Carvalho", "AMF"],
      [81986, "Ivan Zlobin", "GK"],
      [81987, "Andre Da Silva", "RW"],
      [81988, "Cezary Miszta", "GK"],
      [81989, "Yanis Begraoui", "CF"],
      [81990, "Facundo Caseres", "CMF"],
      [81991, "Jonathan Mananga", "CB"],
      [81992, "Jose Mondragon", "CB"],
      [81993, "Diogo Travassos", "RB"],
      [81994, "Joel Da Silva", "CMF"],
      [81995, "Jaume Ciscar", "CMF"],
      [81996, "Lucas Calegari", "RB"],
      [81997, "Lazar Carevi", "GK"],
      [81998, "Andreas Ntoi", "CB"],
      [81999, "Sidney Lima", "CB"],
      [82000, "Said Bakari", "RB"],
      [82001, "Josh Doig", "LB"],
      [82002, "Antonio Caracciolo", "CB"],
      [82003, "Stefano Moreo", "AMF"],
      [82004, "Jari Vandeputte", "CMF"],
      [82005, "Matteo Bianchetti", "CB"],
      [82006, "Anthony Patterson", "GK"],
      [82007, "Dan Ballard", "CB"],
      [82008, "Dennis Cirkin", "LB"],
      [82009, "Timothee Kolodziejczak", "CB"],
      [82010, "Adama Camara", "DMF"],
      [82011, "Obed Nkambadio", "GK"],
      [82012, "Mamadou Sangare", "CMF"],
      [82013, "Koffi Kouao", "RB"],
      [82014, "Jessy Deminguet", "CMF"],
      [82015, "Ally Samatta", "CF"],
      [82016, "Raffaele Di Gennaro", "GK"],
      [82017, "John Ruddy", "GK"],
      [82018, "Doan Alemdar", "GK"],
      [82019, "Oualid El Hajjam", "RB"],
      [82020, "Yehor Yarmoliuk", "CMF"],
      [82021, "Carlos Dominguez", "LW"],
      [82022, "Marco Brescianini", "CMF"],
      [82023, "Alex Gomez", "LB"],
      [82024, "Gabriel Charpentier", "CF"],
      [82025, "Mattia Felici", "LW"],
      [82026, "Torir Helgason", "CMF"],
      [82027, "Balthazar Pierret", "DMF"],
      [82028, "Santiago Pierotti", "RW"],
      [82029, "Dailon Livramento", "CF"],
      [82030, "Myron Boadu", "CF"],
      [82031, "Kiliann Sildillia", "RB"],
      [82032, "Ameen Al Dakhil", "CB"],
      [82033, "Nediljko Labrovic", "GK"],
      [82034, "Samuel Essende", "CF"],
      [82035, "Jakub Kaminski", "LW"],
      [82036, "Ulisses Rocha", "CB"],
      [82037, "Oscar Perea", "LW"],
      [82038, "Timothee Pembele", "RB"],
      [82039, "Sekou Mara", "CF"],
      [82040, "Ngal'Ayel Mukau", "DMF"],
      [82041, "Tom Louchet", "RMF"],
      [82042, "Assane Diousse", "DMF"],
      [82043, "Goduine Koyalipou", "CF"],
      [82044, "Oliver Edvardsen", "LW"],
      [82045, "Can Bozdoan", "CMF"],
      [82046, "Rodrigo Ribeiro", "CF"],
      [82047, "Gil Dias", "RW"],
      [82048, "Andre De Barros", "RB"],
      [82049, "Pedro Santos", "CMF"],
      [82050, "Alexandre Pinto", "RB"],
      [82051, "Myron Van Brederode", "LW"],
      [82052, "Ajdin Hrustic", "AMF"],
      [82053, "Pedro De Lima", "RB"],
      [82054, "Bashir Humphreys", "LB"],
      [82055, "James Hill", "CB"],
      [82056, "Andy Irving", "CMF"],
      [82057, "Nathan Patterson", "RB"],
      [82058, "Tim Iroegbunam", "CMF"],
      [82059, "Andre Ferreira", "GK"],
      [82060, "Jailson Siqueira", "DMF"],
      [82061, "Nicolas Galdeano", "LW"],
      [82062, "Orri Oskarsson", "CF"],
      [82063, "Abderrahman Rebbach", "LW"],
      [82064, "Kevin Bonifazi", "CB"],
      [82065, "Filip Marchwinski", "AMF"],
      [82066, "Jacob Larsen", "LW"],
      [82067, "Eric Ebimbe", "RMF"],
      [82068, "Silvan Widmer", "RB"],
      [82069, "Naouirou Ahamada", "CMF"],
      [82070, "Kassoum Ouattara", "LB"],
      [82071, "Amar Dedi", "RB"],
      [82072, "Victor Jensen", "AMF"],
      [82073, "Bruno Indi", "CB"],
      [82074, "Joao Aurelio", "RB"],
      [82075, "Josafat Mendes", "RB"],
      [82076, "Festy Ebosele", "RB"],
      [82077, "Hannibal Mejbri", "AMF"],
      [82078, "Largie Ramazani", "LW"],
      [82079, "Jhon Romero", "CMF"],
      [82080, "Javier Exposito", "LW"],
      [82081, "Miguel Nobrega", "CB"],
      [82082, "Filipe Soares", "AMF"],
      [82083, "Miguel Perez", "AMF"],
      [82084, "Rafael Barbosa", "AMF"],
      [82085, "Luca De La Torre", "CMF"],
      [82086, "Tadeo Allende", "RW"],
      [82087, "Gvidas Gineitis", "CMF"],
      [82088, "Djaoui Cisse", "CMF"],
      [82089, "Givairo Read", "RB"],
      [82090, "Gjivai Zechil", "CMF"],
      [82091, "Sami Ouaissa", "AMF"],
      [82092, "Francisco Rodrigues", "LB"],
      [82093, "Senny Mayulu", "CMF"],
      [82094, "Kaiky Naves", "CB"],
      [82095, "Tristan Van Gilst", "LW"],
      [82096, "Mees De Wit", "LB"],
      [82097, "Benedito Mukendi", "CMF"],
      [82098, "Hakon Valdimarsson", "GK"],
      [82099, "Ismael Gharbi", "LW"],
      [82100, "Diego Gomez", "CMF"],
      [82101, "Dani Calvo", "CB"],
      [82102, "Alberto Reina", "CMF"],
      [82103, "Joaquin Panichelli", "CF"],
      [82104, "Ghislain Konan", "LB"],
      [82105, "Daniel Figueira", "GK"],
      [82106, "Maroan Sannadi", "CF"],
      [82107, "Adam Karabec", "AMF"],
      [82108, "Afonso Moreira", "LW"],
      [82109, "Unai Arroyo", "CB"],
      [82798, "Witiness Quembo", "RW"],
      [82800, "Paulo Da Silva", "LW"],
      [82810, "Jordi Fernandez", "CF"],
      [82814, "Rojendro Oudsten", "CMF"],
      [82822, "Danny Bakker", "CB"],
      [82823, "Tyrese Noslin", "RMF"],
      [82110, "Jorge Oroz", "CB"],
      [82111, "Mario Rielves", "DMF"],
      [82112, "Javi Rodriguez", "CB"],
      [82113, "Arthur Atta", "CMF"],
      [82114, "Jordan Zemura", "LB"],
      [82115, "Simone Perilli", "GK"],
      [82116, "Clement Akpa", "CB"],
      [82117, "Lasso Coulibaly", "RW"],
      [82118, "Stephane Diarra", "RW"],
      [82119, "Leo Sauer", "LW"],
      [82120, "Levi Smans", "AMF"],
      [82121, "Jacob Trenskow", "RW"],
      [82122, "Baar Nal", "LW"],
      [82123, "Henricus Linthorst", "CMF"],
      [82124, "Kristoffer Peterson", "LW"],
      [82125, "Charles-Andreas Brym", "CF"],
      [82126, "Boy Kemper", "LB"],
      [82127, "Clint Leemans", "CMF"],
      [82128, "Antoni Milambo", "AMF"],
      [82129, "Bryan Linssen", "CF"],
      [82130, "Vito Van Crooij", "RW"],
      [82131, "Jamiro Monteiro", "CMF"],
      [82132, "Younes Namli", "RW"],
      [82133, "Lukas Hornicek", "GK"],
      [82134, "Amine El Ouazzani", "CF"],
      [82135, "Gabriel Aguilera", "LW"],
      [82136, "Pedro Ferreira", "DMF"],
      [82137, "Kevin Boma", "CB"],
      [82138, "Matias Calderon", "CB"],
      [82139, "Adriano Firmino", "DMF"],
      [82140, "Freddie Potts", "DMF"],
      [82141, "Federico Bonazzoli", "CF"],
      [82142, "Serginho", "CMF"],
      [82143, "Luquinhas", "LW"],
      [82144, "Mathys Tourraine", "RB"],
      [82145, "Willem Geubbels", "CF"],
      [82146, "Matheus De Souza", "LB"],
      [82147, "Mariano Diaz", "CF"],
      [82148, "Kendry Paez", "AMF"],
      [82149, "Lucas Bergvall", "CMF"],
      [82150, "Beat Imaz", "CMF"],
      [82151, "Rui Modesto", "RMF"],
      [82152, "Gaby Jean", "CB"],
      [82153, "Hamza Rafia", "CMF"],
      [82154, "Nathan Minpole", "RW"],
      [82155, "Junior Adamu", "CF"],
      [82156, "Marin Ljubicic", "CF"],
      [82157, "Esteban Lepaul", "CF"],
      [82158, "Patrik Carlgren", "GK"],
      [82159, "Henrique Araujo", "DMF"],
      [82160, "Tidjany Toure", "LW"],
      [82161, "Amadou Dante", "LB"],
      [82162, "Ruben Lima", "LB"],
      [82163, "Guilherme Ramos", "CB"],
      [82164, "Dennis Johnsen", "LW"],
      [82165, "Lyle Foster", "CF"],
      [82166, "Charles Pickel", "DMF"],
      [82167, "Luca Koleosho", "RW"],
      [82168, "Mike Penders", "GK"],
      [82169, "Mory Diaw", "GK"],
      [82170, "Kristoffer Lund", "LB"],
      [82171, "Jeremy Sarmiento", "LW"],
      [82172, "Djevencio Van Der Kust", "LB"],
      [82173, "Aiyegun Tosin", "CF"],
      [82174, "Samuel Dahl", "LB"],
      [82175, "Lennard Maloney", "DMF"],
      [82176, "Thijs Oosting", "AMF"],
      [82177, "Joe Worrall", "CB"],
      [82178, "Silvan Hefti", "RB"],
      [82179, "Alessio Zerbin", "RMF"],
      [82180, "Tiago Sa", "GK"],
      [82181, "Boubacar Traore", "DMF"],
      [82182, "Patrick Dorgu", "LB"],
      [82183, "Jacobo Naveros", "CB"],
      [82184, "Alvaro Munoz", "CF"],
      [82185, "Samuele Angori", "LB"],
      [82186, "Luan Patrick", "CB"],
      [82187, "Zico Buurmeester", "CMF"],
      [82188, "Shunsuke Mito", "RW"],
      [82189, "Alec Van Hoorenbeeck", "CB"],
      [82190, "Gustaf Lagerbielke", "CB"],
      [82191, "Andre Sousa", "CMF"],
      [82192, "Ernest Poku", "RW"],
      [82193, "Robin Risser", "GK"],
      [82194, "Giorgi Kochorashvili", "DMF"],
      [82195, "Victor Garcia", "CB"],
      [82196, "Oriol Erenas", "DMF"],
      [82197, "Pablo Martinez", "CMF"],
      [82198, "Roger Ayguade", "LW"],
      [82199, "Haissem Hassan", "RW"],
      [82200, "David Costas", "CB"],
      [82201, "Ilyas Chaira", "LW"],
      [82202, "Georgiy Tsitaishvili", "RW"],
      [82203, "Joris Van Overeem", "DMF"],
      [82204, "Ricard Sendra", "RB"],
      [82205, "Joao Carvalho", "AMF"],
      [82206, "Jordan Holsgrove", "DMF"],
      [82207, "Joao Mendes", "LB"],
      [82208, "Mahamadou Diawara", "CMF"],
      [82209, "Alex Murphy", "LB"],
      [82210, "Tyrique George", "LW"],
      [82799, "Lucas De Franca", "GK"],
      [82803, "Lucas Joao", "CF"],
      [82808, "Diogo Marques", "LB"],
      [82211, "Roberto Jaen", "CF"],
      [82212, "Karl Hein", "GK"],
      [82213, "Mikael Ellertsson", "CMF"],
      [82214, "Paul Wanner", "AMF"],
      [82215, "Lewis Holtby", "CMF"],
      [82216, "Ousmane Camara", "CB"],
      [82217, "Angel Esteves", "DMF"],
      [82218, "Richonell Margaret", "RW"],
      [82219, "Thijmen Blokzijl", "CB"],
      [82220, "Thom Van Bergen", "CF"],
      [82221, "Syb Van Ottele", "CB"],
      [82222, "Thomas Bruns", "AMF"],
      [82223, "Rodrigo Ferreira", "RB"],
      [82224, "Taichi Fukui", "CMF"],
      [82225, "Matheus Dias", "DMF"],
      [82226, "Simone Canestrelli", "CB"],
      [82227, "Idrissa Toure", "RMF"],
      [82228, "Melle Meulensteen", "DMF"],
      [82229, "Houboulang Mendes", "RB"],
      [82230, "Mike Wierik", "CB"],
      [82231, "Marc Gual", "CF"],
      [82232, "Wendel", "CF"],
      [82233, "Vincent Marchetti", "CMF"],
      [82234, "Junior Diaz", "CB"],
      [82235, "Alaa Bellaarouch", "GK"],
      [82236, "Diogo Pinto", "GK"],
      [82237, "Adria Reynaldos", "RB"],
      [82238, "Urko Quiros", "DMF"],
      [82239, "Jon Imizcoz", "CMF"],
      [82240, "Leonidas Stergiou", "RB"],
      [82241, "James Sands", "DMF"],
      [82242, "David Min", "CF"],
      [82243, "Odysseus Velanas", "AMF"],
      [82244, "Jean Gorby", "CMF"],
      [82245, "Alejandro Gomez", "CMF"],
      [82246, "Miguel De Sousa", "AMF"],
      [82247, "Jose Ferreira", "CMF"],
      [82248, "Caio Secco", "GK"],
      [82249, "Hobie Verhulst", "GK"],
      [82250, "Matija Frigan", "CF"],
      [82251, "Semih Klsoy", "CF"],
      [82252, "Sandro Lima", "CF"],
      [82253, "Chris Rigg", "AMF"],
      [82254, "Panos Katseris", "RMF"],
      [82255, "German Karabinaite", "RW"],
      [82256, "Gerard Martin", "LB"],
      [82257, "Facundo Garces", "CB"],
      [82258, "Brooke Norton-Cuffy", "RB"],
      [82259, "Shiloh Zand", "AMF"],
      [82260, "Kolbeinn Finnsson", "LB"],
      [82261, "Younes Taha", "RW"],
      [82262, "Gianluca Prestianni", "RW"],
      [82263, "Joao Da Graa", "CMF"],
      [82264, "Goncalo Costa", "LB"],
      [82265, "Pablo Gilabert", "AMF"],
      [82266, "Paris Maghoma", "CMF"],
      [82267, "Nicholas Pierini", "RW"],
      [82268, "Souleymane Toure", "CB"],
      [82269, "Emanuel Vignato", "RW"],
      [82270, "Matisse Didden", "CB"],
      [82271, "Goncalo Esteves", "RB"],
      [82272, "Robin Hranac", "CB"],
      [82273, "Daniel Peretz", "GK"],
      [82274, "Ayden Heaven", "CB"],
      [82275, "Matias Moreno", "CB"],
      [82276, "Daniel Rivas", "LB"],
      [82277, "Mexx Meerdink", "CF"],
      [82278, "Denso Kasius", "RB"],
      [82279, "Maxim Dekker", "CB"],
      [82280, "Max Bruns", "CB"],
      [82281, "Przemyslaw Tyton", "GK"],
      [82282, "Simo Bertelli", "GK"],
      [82283, "Juan Mina", "RB"],
      [82284, "Virgil Misidjan", "LW"],
      [82285, "Charalampos Kostoulas", "CF"],
      [82286, "Nelson Deossa", "CMF"],
      [82287, "Aleix Febas", "CMF"],
      [82288, "Alex Fores", "CF"],
      [82289, "Chidozie Awaziem", "CB"],
      [82290, "Luis Gomes", "AMF"],
      [82291, "Patrick De Paula", "DMF"],
      [82292, "Luis Esteves", "AMF"],
      [82293, "Agustin Moreira", "RW"],
      [82294, "Joao Afonso", "CB"],
      [82295, "William Osula", "CF"],
      [82296, "Achraf Laaziri", "LB"],
      [82297, "Mark Gillespie", "GK"],
      [82801, "Jesus Diaz", "CF"],
      [82802, "Motez Nourani", "LW"],
      [82805, "Robson Botelho", "CMF"],
      [82809, "Gustavo Mendonca", "CMF"],
      [82811, "Diego Garcete", "CF"],
      [82818, "Neville Nwankwo", "CB"],
      [82821, "Dylan Mertens", "AMF"],
      [82825, "Patrick Brouwer", "LW"],
      [82298, "Brandon Austin", "GK"],
      [82299, "Alfonso Martinez", "LW"],
      [82300, "Michel Adopo", "CMF"],
      [82301, "Yanis Zouaoui", "LB"],
      [82302, "Dylan Mbayo", "RW"],
      [82303, "Mohamed Nassoh", "AMF"],
      [82304, "Mario Engels", "LW"],
      [82305, "Ivan Mesik", "CB"],
      [82306, "Ryan Fosso", "CMF"],
      [82307, "Luka Kulenovic", "CF"],
      [82308, "Joao Valido", "GK"],
      [82309, "Nicolo Bertola", "CB"],
      [82310, "Tyrhys Dolan", "RW"],
      [82311, "Theo Le Bris", "LMF"],
      [82312, "Pedro Trigueira", "GK"],
      [82313, "Will Dennis", "GK"],
      [82314, "Ivan Sacristan", "GK"],
      [82315, "Christian Ordoez", "CMF"],
      [82316, "John Furtado", "GK"],
      [82317, "Liziero", "CMF"],
      [82318, "Bertu Yldrm", "CF"],
      [82319, "Niccolo Pisilli", "CMF"],
      [82320, "Mathias Honsak", "LW"],
      [82321, "Andre Gomes", "GK"],
      [82322, "Joao Garces", "AMF"],
      [82323, "Gregoire Coudert", "GK"],
      [82324, "Remy Lascary", "CF"],
      [82325, "Jayden Addai", "RW"],
      [82326, "Mathis Suray", "AMF"],
      [82327, "Ryan Thomas", "CMF"],
      [82328, "Jorg Schreuders", "RW"],
      [82329, "Ibrahim Osman", "LW"],
      [82330, "Brandon Aguilera", "AMF"],
      [82331, "Diogo Calila", "RB"],
      [82332, "Max Rio", "CF"],
      [82333, "Issiar Drame", "CB"],
      [82334, "Telasco Segovia", "CMF"],
      [82335, "Manuel De Luca", "CF"],
      [82336, "Chemsdine Talbi", "RW"],
      [82337, "Romaine Mundle", "LW"],
      [82338, "Wilson Isidor", "CF"],
      [82339, "Uros Radakovic", "CB"],
      [82340, "Igor De Almeida", "RB"],
      [82341, "Jean-Victor Makengo", "CMF"],
      [82342, "Francisco Sierralta", "CB"],
      [82343, "Marc Paz", "CF"],
      [82344, "Romain Esse", "RW"],
      [82345, "Warren Bondo", "CMF"],
      [82346, "Anass Salah-Eddine", "LB"],
      [82347, "Damian Pizarro", "CF"],
      [82348, "Julien Duranville", "LW"],
      [82349, "Igor Matanovic", "CF"],
      [82350, "Fredrik Oppegrd", "LB"],
      [82351, "Jacques Ekomie", "LB"],
      [82352, "Lilian Raolisoa", "RB"],
      [82353, "Jan Ambrek", "CMF"],
      [82354, "Babatunde Akinsola", "LW"],
      [82355, "Jeff Reine-Adelade", "AMF"],
      [82356, "Olivier Deman", "LB"],
      [82357, "Antoine Joujou", "LW"],
      [82358, "Hamzat Ojediran", "DMF"],
      [82359, "Calvin Twigt", "DMF"],
      [82360, "Hidde Jurjus", "GK"],
      [82361, "Diangana", "RW"],
      [82362, "Mohamed Bamba", "CF"],
      [82363, "Cristian Volpato", "AMF"],
      [82364, "Kevin Danois", "CMF"],
      [82365, "Conrad Harder", "CF"],
      [82366, "Mathias De Amorim", "CMF"],
      [82367, "Louis Leroux", "AMF"],
      [82368, "Dave Kwakman", "CMF"],
      [82369, "Figueiredo", "LW"],
      [82370, "Matthew Cox", "GK"],
      [82371, "Angel Vias", "GK"],
      [82372, "Pio Esposito", "CF"],
      [82373, "Matheus De Araujo", "LB"],
      [82374, "Ruben Saez", "RB"],
      [82375, "Miguel Lestan", "CB"],
      [82376, "Jose Moran", "LB"],
      [82377, "Jiri Letacek", "GK"],
      [82378, "Pablo Campos", "GK"],
      [82379, "Oier Luengo", "CB"],
      [82380, "Tuomas Ollila", "LB"],
      [82381, "Samson Baidoo", "CB"],
      [82382, "Sydney Van Hooijdonk", "CF"],
      [82383, "Brandley Kuwas", "RW"],
      [82384, "Henk Veerman", "CF"],
      [82385, "Jeremy Livolant", "LW"],
      [82386, "Gustavo Silva", "RW"],
      [82387, "Hyun-Ju Lee", "AMF"],
      [82388, "Dinis Pinto", "RB"],
      [82389, "Vasco Sousa", "CMF"],
      [82390, "Yarlen Augusto", "RW"],
      [82391, "Andre Ceitil", "DMF"],
      [82392, "Ruben Kluivert", "CB"],
      [82393, "Alejandro Perez", "GK"],
      [82394, "Harrison Ashby", "RB"],
      [82395, "Josh Acheampong", "RB"],
      [82396, "Trey Nyoni", "CMF"],
      [82397, "Chido Obi", "CF"],
      [82812, "Soufiane Hetli", "CF"],
      [82824, "Nigel Nwankwo", "LB"],
      [82398, "Drissa Camara", "CMF"],
      [82399, "Kamara", "RW"],
      [82400, "Jose Gomes", "LB"],
      [82401, "Brayann Pereira", "RB"],
      [82402, "Jasper Dahlhaus", "LB"],
      [82403, "Boyd Lucassen", "RB"],
      [82404, "Tarik Muharemovi", "CB"],
      [82405, "Malthe Hjholt", "DMF"],
      [82406, "Alvaro Collazo", "RB"],
      [82407, "Brandon Domingues", "AMF"],
      [82408, "Alimami Gory", "LW"],
      [82409, "Sambou Soumano", "CF"],
      [82410, "Lucas Conchello", "GK"],
      [82411, "Jhon Arias", "RW"],
      [82412, "Pablo Tejada", "AMF"],
      [82413, "Niklas Vesterlund", "RB"],
      [82414, "Sren Tengstedt", "AMF"],
      [82415, "Luca Plogmann", "GK"],
      [82416, "Raul Paula", "AMF"],
      [82417, "Joao Simes", "CMF"],
      [82418, "Myles Peart-Harris", "AMF"],
      [82419, "Ransford Knigsdrffer", "CF"],
      [82420, "Willy Kambwala", "CB"],
      [82421, "Antoniu Vives", "RW"],
      [82422, "Iker Solanilla", "CF"],
      [82423, "Noah Ohio", "CF"],
      [82424, "Luuk Koopmans", "GK"],
      [82425, "Joel Mvuka", "RW"],
      [82426, "Iker Sanchez", "RW"],
      [82427, "Alan Romero", "CB"],
      [82428, "Aurele Amenda", "CB"],
      [82429, "Finn Stokkers", "CF"],
      [82430, "Rui Mendes", "RW"],
      [82431, "Bryan Ekango", "RW"],
      [82432, "Aaron Meijers", "LB"],
      [82433, "Sphephelo Sithole", "CMF"],
      [82434, "Gino Infantino", "CMF"],
      [82435, "Dario Piki", "LW"],
      [82436, "Maxime Colin", "RB"],
      [82437, "Nikita Baranovsky", "GK"],
      [82438, "Alberto Cerri", "CF"],
      [82439, "Cher Ndour", "CMF"],
      [82440, "Thomas Buitink", "CF"],
      [82441, "Pietro Comuzzo", "CB"],
      [82442, "Alberto Baio", "RB"],
      [82443, "Felix Mambimbi", "LW"],
      [82444, "Patrizio Masini", "CMF"],
      [82445, "Joe Hodge", "DMF"],
      [82446, "Thomas Van Den Belt", "DMF"],
      [82447, "Pedro Pacheco", "CB"],
      [82448, "Alvaro Nuez", "RB"],
      [82449, "Bambo Diaby", "CB"],
      [82450, "Adrian Liso", "LW"],
      [82451, "Diego Pampin", "LB"],
      [82452, "Kwasi Sibo", "CMF"],
      [82453, "Terry Yegbe", "CB"],
      [82454, "Shurandy Sambo", "RB"],
      [82455, "Mathijs Tielemans", "CMF"],
      [82456, "Szymon Wlodarczyk", "CF"],
      [82457, "Casper Widell", "CB"],
      [82458, "Xavier Mbuyamba", "CB"],
      [82459, "Kevin Prieto", "RW"],
      [82460, "Sergio Bermejo", "RW"],
      [82461, "Hevertton Santos", "RB"],
      [82462, "Brian Mansilla", "LW"],
      [82463, "Bernardo Martin", "LW"],
      [82464, "Cedric Teguia", "LW"],
      [82465, "Ivan Cavaleiro", "LW"],
      [82466, "Filip Jrgensen", "GK"],
      [82813, "Ronald Jr", "GK"],
      [82467, "Theo De Percin", "GK"],
      [82468, "Zidane Iqbal", "CMF"],
      [82469, "Tika De Jonge", "CMF"],
      [82470, "Mimeirhel Benita", "RB"],
      [82471, "Sem Scheperman", "DMF"],
      [82472, "Paulo Victor", "LB"],
      [82473, "Tommaso Barbieri", "RB"],
      [82474, "Noah Cadiou", "CMF"],
      [82475, "Pablo Pagis", "CF"],
      [82476, "Fode Doucoure", "RB"],
      [82477, "Teo Leon", "CB"],
      [82478, "Sava-Arangel Esti", "CB"],
      [82479, "Diogo Martins", "AMF"],
      [82480, "Leo Santos", "CB"],
      [82481, "Ianis Stoica", "LW"],
      [82482, "Hugo Antunez", "LW"],
      [82483, "Nicolo Savona", "RB"],
      [82484, "Emmanuel Biumla", "CB"],
      [82485, "Louis Mouton", "CMF"],
      [82486, "Wouter Prins", "LB"],
      [82487, "Jannes Wieckhoff", "RB"],
      [82488, "Mats Seuntjens", "LW"],
      [82489, "Edouard Michut", "CMF"],
      [82490, "Joao Baptista", "RB"],
      [82491, "Oscar Viondi", "CB"],
      [82492, "Simon Elisor", "CF"],
      [82493, "Igor Jesus", "CF"],
      [82494, "Samuel Ballet", "RW"],
      [82495, "Lohann Doucet", "DMF"],
      [82496, "Abu Francis", "CMF"],
      [82497, "Jean-Philippe Gbamin", "DMF"],
      [82498, "Jesus Rodriguez", "LW"],
      [82499, "Danel Sinani", "AMF"],
      [82500, "Brynjolfur Willumsson", "CF"],
      [82501, "Fredrik Jensen", "DMF"],
      [82502, "Enes Mahmutovic", "CB"],
      [82503, "Gilberto Batista", "CB"],
      [82504, "Arturo Calabresi", "CB"],
      [82505, "Dermane Karim", "DMF"],
      [82506, "Nathaniel Adjei", "CB"],
      [82507, "Lamare Bogarde", "CB"],
      [82508, "Manuel Sebastian", "CMF"],
      [82509, "Reda Belahyane", "DMF"],
      [82510, "Connor Metcalfe", "CMF"],
      [82511, "Mathis Amougou", "CMF"],
      [82512, "Rick Meissen", "CB"],
      [82513, "Jaydon Banel", "LW"],
      [82514, "Afonso Rodrigues", "LW"],
      [82515, "Amourrichio Dongen", "LW"],
      [82516, "Elysee Logbo", "CF"],
      [82517, "Tobias Medina", "LW"],
      [82518, "Dies Janse", "CB"],
      [82519, "Nobel Mendy", "CB"],
      [82520, "Damian Van Der Haar", "CB"],
      [82521, "Tom De Graaff", "GK"],
      [82522, "Abdelhamid Boudlal", "CB"],
      [82523, "Henrik Meister", "CF"],
      [82524, "Emersonn", "CF"],
      [82525, "Jon Martin", "CB"],
      [82526, "Morgan Bokele", "LW"],
      [82527, "Fode Sylla", "DMF"],
      [82528, "Johan Manzambi", "CMF"],
      [82529, "Makan Ako", "LW"],
      [82530, "Luca Marianucci", "CB"],
      [82531, "James McConnell", "DMF"],
      [82532, "Issam El Maach", "GK"],
      [82533, "Hugo Cunha", "GK"],
      [82534, "Francisco Silva", "RW"],
      [82535, "Julio Soler", "LB"],
      [82536, "Arokodare", "CF"],
      [82537, "Fer Lopez", "RW"],
      [82538, "Victor Raja", "RB"],
      [82539, "Ivan Araque", "CF"],
      [82540, "Rahim Alhassane", "LB"],
      [82541, "Lucas Ahijado", "RB"],
      [82542, "Luka Ili", "AMF"],
      [82543, "Daouda Guindo", "LB"],
      [82544, "Konstantinos Lamprou", "GK"],
      [82545, "Kamal Sowah", "RW"],
      [82546, "Arthur Zagre", "LB"],
      [82547, "Robert Muhren", "CF"],
      [82548, "Fabricio Garcia", "RW"],
      [82549, "Nas Djouahra", "LW"],
      [82816, "Sebastiaan Hagedoorn", "CF"],
      [82819, "Jochem Van De Kamp", "CMF"],
      [82826, "Nils Rossen", "CMF"],
      [82827, "Yamano Olfers", "CB"],
      [82550, "Dean James", "LB"],
      [82551, "Santiago Gonzalez", "AMF"],
      [82552, "Mauro Vigorito", "GK"],
      [82553, "Emirhan Lkhan", "CMF"],
      [82554, "Edoardo Corvi", "GK"],
      [82555, "Claudio Vicente", "CF"],
      [82556, "Alex Mighten", "LW"],
      [82557, "Tomas Esteves", "RB"],
      [82558, "Jonathan Fischer", "GK"],
      [82559, "Damian Sousa", "DMF"],
      [82560, "Hugo Gomez", "CMF"],
      [82561, "Saba Goglichidze", "CB"],
      [82562, "Mikayil Faye", "CB"],
      [82563, "Bilal Nadir", "CMF"],
      [82564, "Ethan Mbappe", "CMF"],
      [82565, "Yassin Belkhdim", "CMF"],
      [82566, "Miguel Garcia", "LW"],
      [82567, "Joao Costa", "CF"],
      [82568, "Justin Lonwijk", "CMF"],
      [82569, "Joel Asoro", "RW"],
      [82570, "Jesus Perez", "CMF"],
      [82571, "Iker Cameros", "DMF"],
      [82572, "Tristan Gooijer", "RB"],
      [82573, "Casper Staring", "DMF"],
      [82574, "Anthony Descotte", "CF"],
      [82575, "Joao Rego", "AMF"],
      [82576, "William Gomes", "LW"],
      [82577, "Mehdi Leris", "RW"],
      [82578, "Walid Ould-Chikh", "AMF"],
      [82579, "Tomas Palacios", "CB"],
      [82580, "Tygo Land", "CMF"],
      [82581, "Lequincio Zeefuik", "CF"],
      [82582, "Aske Adelgaard", "LB"],
      [82583, "Yann Lienard", "GK"],
      [82584, "Kees Smit", "CMF"],
      [82585, "Victor Froholdt", "CMF"],
      [82586, "Marko Milovanovi", "CF"],
      [82587, "Mourad El Ghezouani", "CF"],
      [82588, "John Okeh", "CB"],
      [82589, "Pathe Mboup", "LW"],
      [82590, "Hristiyan Petrov", "CB"],
      [82591, "Maxence Rivera", "LW"],
      [82592, "Young", "CB"],
      [82593, "Moussa Soumano", "CF"],
      [82594, "Orest Lebedenko", "LB"],
      [82595, "Joelson Fernandes", "LW"],
      [82596, "Antonio Espigares", "CB"],
      [82597, "Francisco Domingues", "LB"],
      [82598, "Christian Marques", "CB"],
      [82817, "Milan Zonneveld", "CF"],
      [82829, "Abdelraffie Benzzine", "CB"],
      [82599, "Abraham Marcus", "RW"],
      [82600, "Kaique Pereira", "GK"],
      [82601, "Gabriele Piccinini", "CMF"],
      [82602, "Remi Matthews", "GK"],
      [82603, "Enso Gonzalez", "LW"],
      [82604, "Ovie Ejaria", "LW"],
      [82605, "Daniele Sommariva", "GK"],
      [82606, "Tino Anjorin", "AMF"],
      [82607, "Bence Dardai", "AMF"],
      [82608, "Milan Smit", "CF"],
      [82609, "Telmo Arcanjo", "RW"],
      [82610, "Pedro Bondo", "LB"],
      [82611, "Nelson Abbey", "CB"],
      [82612, "Noe Lebreton", "DMF"],
      [82613, "Eliezer Mayenda", "CF"],
      [82614, "Julien Lopez", "LW"],
      [82615, "Anthony Bermont", "LW"],
      [82616, "Michel Mboula", "CB"],
      [82617, "Godson Kyeremeh", "RW"],
      [82618, "Oliver Scarles", "LB"],
      [82619, "Marc Bernal", "DMF"],
      [82620, "Adrian Blake", "LW"],
      [82621, "Nick Fichtinger", "DMF"],
      [82622, "Deniz Gul", "CF"],
      [82623, "Francisco Petrasso", "CB"],
      [82624, "Ebenezer Akinsanmiro", "CMF"],
      [82625, "Pau Delgado", "CF"],
      [82626, "Nhoa Sangui", "LB"],
      [82627, "Kaj De Rooij", "RW"],
      [82628, "Franois Mughe", "RW"],
      [82629, "Samir Chergui", "CB"],
      [82630, "Julius Dirksen", "CB"],
      [82631, "Nikitscher", "CMF"],
      [82632, "Koen Kostons", "CF"],
      [82633, "Francesco Rossi", "GK"],
      [82634, "Jasper Samooja", "GK"],
      [82635, "Eric Moreira", "RB"],
      [82636, "Rodrigo Duarte", "RW"],
      [82637, "Harry Tyrer", "GK"],
      [82638, "Mattia Chiesa", "GK"],
      [82639, "Sondre Rjaster", "LW"],
      [82640, "Andre Paulo", "GK"],
      [82641, "Nabil Touaizi", "CF"],
      [82642, "Tani Oluwaseyi", "CF"],
      [82643, "Vaclav Sejk", "CF"],
      [82644, "Marcus Linday", "CMF"],
      [82645, "Lance Duijvestijn", "AMF"],
      [82646, "Velthuis", "CB"],
      [82647, "Andre Lacximicant", "LW"],
      [82648, "Kaique Rocha", "CB"],
      [82649, "David Sousa", "CB"],
      [82650, "Vando Felix", "LW"],
      [82651, "Juan Castillo", "GK"],
      [82652, "Carlos Eduardo", "CF"],
      [82653, "Gustavo Varela", "CF"],
      [82654, "Brayan Medina", "CB"],
      [82655, "Remy Vita", "LB"],
      [82656, "Owen Bevan", "CB"],
      [82657, "Mathias Lvik", "LB"],
      [82658, "Alejandro Encabo", "GK"],
      [82659, "Mohamed Mete", "CF"],
      [82660, "Kento Shiogai", "CF"],
      [82661, "Jefferson Encada", "RB"],
      [82662, "Giuseppe Ciocci", "GK"],
      [82663, "Mateo Pellegrino", "CF"],
      [82664, "Luck Zogbe", "RB"],
      [82665, "Justin Bourgault", "LB"],
      [82666, "Rafik Messali", "RMF"],
      [82667, "Noam Emeran", "LW"],
      [82668, "Daniel Azevedo", "GK"],
      [82669, "Pierre-Yves Hamel", "CF"],
      [82670, "Coba Da Costa", "LW"],
      [82671, "Arnau Sola", "LB"],
      [82672, "Justin-Nol Kalumba", "RW"],
      [82673, "Melvin Zinga", "GK"],
      [82674, "Cesar Augusto", "GK"],
      [82675, "Oskar Sivertsen", "LW"],
      [82676, "Oscar Pettersson", "RW"],
      [82677, "Pedro Santos", "RW"],
      [82678, "Stanis Idumbo", "AMF"],
      [82679, "Pablo Garcia", "RW"],
      [82680, "Mateo Flores", "CMF"],
      [82681, "Ali Dembele", "RMF"],
      [82682, "Erik Ahlstrand", "CMF"],
      [82683, "Daouda Weidmann", "CMF"],
      [82684, "Francesco Folino", "CB"],
      [82685, "Xander Blomme", "DMF"],
      [82686, "Justin Devenny", "CMF"],
      [82687, "Samuel Amo-Ameyaw", "RW"],
      [82688, "Gustavo Nunes", "LW"],
      [82689, "Francesco Camarda", "CF"],
      [82690, "Brenner", "RW"],
      [82691, "Samir Lagsir", "AMF"],
      [82692, "Argyris Darelas", "AMF"],
      [82693, "Lamine Sy", "RB"],
      [82694, "Kyllian Antonio", "CB"],
      [82695, "Noah Edjouma", "RW"],
      [82696, "Sidiki Cherif", "CF"],
      [82697, "Lorenzo Milani", "LB"],
      [82698, "Isak Hansen-Aaren", "AMF"],
      [82699, "Roy Kortsmit", "GK"],
      [82700, "Thibo Baeten", "CF"],
      [82701, "Otar Mamageishvili", "CMF"],
      [82702, "Theofanis Bakoulas", "DMF"],
      [82703, "Tom Watson", "LW"],
      [82704, "Yunus Konak", "DMF"],
      [82705, "Etta Eyong", "CF"],
      [82706, "Marius Courcoul", "DMF"],
      [82707, "Mohamed Bamba", "DMF"],
      [82708, "Pedro Lima", "CMF"],
      [82709, "Vasilije Adi", "AMF"],
      [82710, "Jeff Ekhator", "CF"],
      [82711, "Alpha Toure", "DMF"],
      [82712, "Rudy Matondo", "CMF"],
      [82713, "Travis Hernes", "CMF"],
      [82714, "Sekou Doucoure", "CB"],
      [82715, "Romeo Beney", "LW"],
      [82716, "Lanroy Machine", "CF"],
      [82717, "Tristan Schenkhuizen", "DMF"],
      [82718, "Honest Ahanor", "LB"],
      [82719, "Alessio Furlanetto", "GK"],
      [82720, "Bastien Meupiyou", "CB"],
      [82721, "Marc Girona", "GK"],
      [82722, "Marius Broholm", "RW"],
      [82723, "Santiago Hidalgo", "CF"],
      [82724, "Tomas Mendes", "DMF"],
      [82725, "Julian Martinez", "CB"],
      [82726, "Sabit Abdulai", "DMF"],
      [82727, "Abdoulaye Faye", "CB"],
      [82728, "Marcos Pena", "CMF"],
      [82729, "Anthony Carter", "CF"],
      [82730, "Steven Baseya", "CB"],
      [82731, "Giorgi Abuashvili", "LW"],
      [82732, "Dirk Baron", "GK"],
      [82733, "Nando Verdoni", "GK"],
      [82734, "Stav Lemkin", "CB"],
      [82735, "Rijk Janse", "GK"],
      [82736, "Duke Verduin", "GK"],
      [82737, "Shoretire", "LW"],
      [82738, "Niels Martens", "GK"],
      [82739, "Ramazan Bayram", "GK"],
      [82740, "Timo Jansink", "GK"],
      [82741, "Adam Boayar", "AMF"],
      [82742, "Rodrigo Mendoza", "CMF"],
      [82743, "Jorge Cabello", "CB"],
      [82744, "Carlos Espi", "CF"],
      [82745, "Nidal Celik", "CB"],
      [82746, "Dayann Methalie", "CB"],
      [82747, "Nicolas Wasbauer", "CB"],
      [82748, "Amady Camara", "CF"],
      [82749, "Eser Gurbuz", "RW"],
      [82750, "Nikolai Hopland", "CB"],
      [82751, "Nkkvi Thorisson", "CF"],
      [82752, "Cherrion Valerius", "RB"],
      [82753, "Juho Talvitie", "RW"],
      [82754, "Noah Naujoks", "AMF"],
      [82755, "Derensili Fernandes", "RW"],
      [82756, "Ilias Bronkhorst", "RB"],
      [82757, "Lennard Hartjes", "CMF"],
      [82758, "Do-Young Yoon", "RW"],
      [82759, "Irakli Yegoian", "CMF"],
      [82760, "Zach Booth", "LW"],
      [82761, "Calvin Raatsie", "GK"],
      [82762, "Adam Carlen", "DMF"],
      [82763, "Nadje", "AMF"],
      [82764, "Gyan De Regt", "LW"],
      [82765, "Gibson Yah", "CMF"],
      [82766, "Ideho", "LW"],
      [82767, "Silvinho Esajas", "CB"],
      [82768, "Yannick Leliendal", "LB"],
      [82769, "Kiano Dyer", "CMF"],
      [82770, "Verschuren", "CB"],
      [82771, "Deron Payne", "RB"],
      [82772, "Mawouna Amevor", "CB"],
      [82773, "Roy Steur", "GK"],
      [82774, "Kayne Van Oevelen", "GK"],
      [82775, "Ozan Kkcu", "LW"],
      [82776, "Precious Ugwu", "CB"],
      [82777, "Martin Turk", "GK"],
      [82778, "Abdu Conte", "LB"],
      [82779, "Korede Osundina", "RW"],
      [82780, "Xander Severina", "RW"],
      [82781, "Alioune Ndoye", "CF"],
      [82782, "Fabio Blanco", "LW"],
      [82783, "Goncalo Nogueira", "CMF"],
      [82784, "Tony Strata", "RB"],
      [82785, "Jonathan Mutombo", "RB"],
      [82786, "Van Ee", "CMF"],
      [82787, "Diogo Monteiro", "CB"],
      [82788, "Omar Fayed", "CB"],
      [82789, "Luis Semedo", "CF"],
      [82790, "Rodri Alonso", "CMF"],
      [82791, "Yan Maranho", "CF"],
      [82792, "Michel", "CB"],
      [82793, "Helder Tavares", "CMF"],
      [82794, "Valdemiro Domingos", "CF"],
      [82795, "Juan Lopez", "DMF"],
      [82796, "Xabi Huarte", "AMF"],
      [82797, "Nor Maviram", "LB"],
    ];

    var cdnBase = window.baseLinkCDN || "";
    var locale = document.body.className.trim().split(/\s+/)[0] || "en";
    var TEXT = {
      vn: {
        add: "Thêm",
        noResult: "Không tìm thấy cầu thủ",
        placeholder: "Tên cầu thủ",
      },
      en: {
        add: "Add",
        noResult: "No player found",
        placeholder: "Player name",
      },
      th: {
        add: "เพิ่ม",
        noResult: "ไม่พบผู้เล่น",
        placeholder: "ชื่อผู้เล่น",
      },
      id: {
        add: "Tambah",
        noResult: "Pemain tidak ditemukan",
        placeholder: "Nama pemain",
      },
    };
    var t = TEXT[locale] || TEXT.en;
    var PLAYER_SAMPLE =
      cdnBase + "assets/tf-26-preregister-builder/images/player/80000.png";
    var PLAYER_IMG_DIR = PLAYER_SAMPLE.substring(
      0,
      PLAYER_SAMPLE.lastIndexOf("/") + 1,
    );
    var PLAYER_IMG_EXT = PLAYER_SAMPLE.substring(
      PLAYER_SAMPLE.lastIndexOf("."),
    );
    var INITIAL_RESULTS = 10;
    var LOAD_MORE_STEP = 10;
    var currentSlotIndex = null;
    var activePosition = null; // null = tất cả
    var filteredPlayers = [];
    var renderedCount = 0;

    var $popup = $("#popup_builder");
    var $input = $popup.find(".input__search");
    var $btnSearch = $popup.find(".btn__search");
    var $btnReset = $popup.find(".btn__reset");
    var $results = $popup.find(".group__results");
    var $posItems = $popup.find(".group__select--item");

    $input.attr("placeholder", t.placeholder);

    // ============ FILTER (search + position kết hợp) ============
    function filterPlayers(query, position) {
      var q = (query || "").trim().toLowerCase();
      var out = [];
      for (var i = 0; i < players.length; i++) {
        var p = players[i]; // [id, name, pos]
        var matchPos = !position || p[2] === position;
        var matchQ = !q || p[1].toLowerCase().indexOf(q) !== -1;
        if (matchPos && matchQ) out.push(p);
      }
      return out;
    }

    function getSelectedPlayerIdMap() {
      var selected = {};
      if (
        !window.TeamBuilder ||
        typeof window.TeamBuilder.getSlots !== "function"
      ) {
        return selected;
      }

      var slots = window.TeamBuilder.getSlots() || [];
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        if (!slot || slot.id === undefined || slot.id === null) continue;
        // Cho phép giữ nguyên cầu thủ ở chính slot đang sửa
        if (i === currentSlotIndex) continue;
        selected[String(slot.id)] = true;
      }

      return selected;
    }

    function buildResultItem(player, selectedIdMap) {
      var id = player[0];
      var name = player[1];
      var isDisabled = !!selectedIdMap[String(id)];
      var itemClass = isDisabled ? "result__item is-disabled" : "result__item";
      return (
        '<div class="' +
        itemClass +
        '" data-id="' +
        id +
        '" data-name="' +
        name +
        '" data-disabled="' +
        (isDisabled ? "1" : "0") +
        '">' +
        '<img src="' +
        PLAYER_IMG_DIR +
        id +
        PLAYER_IMG_EXT +
        '" alt="' +
        name +
        '" />' +
        '<a href="#" class="result__add-item">' +
        t.add +
        "</a>" +
        "</div>"
      );
    }

    function renderNextBatch(size) {
      if (!filteredPlayers.length) {
        $results.html('<p class="no-result">' + t.noResult + "</p>");
        return;
      }

      var start = renderedCount;
      var end = Math.min(renderedCount + size, filteredPlayers.length);
      if (start >= end) return;

      var selectedIdMap = getSelectedPlayerIdMap();
      var html = "";
      for (var i = start; i < end; i++) {
        html += buildResultItem(filteredPlayers[i], selectedIdMap);
      }

      if (start === 0) {
        $results.html(html);
      } else {
        $results.append(html);
      }

      renderedCount = end;
    }

    function applyFilters() {
      filteredPlayers = filterPlayers($input.val(), activePosition);
      renderedCount = 0;
      $results.empty();
      renderNextBatch(INITIAL_RESULTS);
      $results.scrollTop(0);
    }

    // ============ OPEN / CLOSE ============
    function openPopup(slotIndex) {
      currentSlotIndex = slotIndex;
      activePosition = null;
      $input.val("");
      $posItems.removeClass("active");
      applyFilters();
      $popup.addClass("active");
    }

    // ============ EVENTS ============
    $btnSearch.on("click", applyFilters);

    $input.on("keyup", applyFilters);

    $btnReset.on("click", function () {
      activePosition = null;
      $input.val("");
      $posItems.removeClass("active");
      applyFilters();
    });

    // Click chọn position
    $popup.on("click", ".group__select--item", function (e) {
      e.preventDefault();
      var pos = $(this).data("pos");
      if (activePosition === pos) {
        // toggle off
        activePosition = null;
        $(this).removeClass("active");
      } else {
        activePosition = pos;
        $posItems.removeClass("active");
        $(this).addClass("active");
      }
      applyFilters();
    });

    // Scroll tới gần cuối thì load thêm
    $results.on("scroll", function () {
      var node = this;
      if (renderedCount >= filteredPlayers.length) return;
      if (node.scrollTop + node.clientHeight >= node.scrollHeight - 20) {
        renderNextBatch(LOAD_MORE_STEP);
      }
    });

    $results.on("click", ".result__add-item", function (e) {
      e.preventDefault();
      var $item = $(this).closest(".result__item");
      if ($item.attr("data-disabled") === "1") return;

      var id = parseInt($item.data("id"), 10);
      var name = $item.data("name");

      // Chặn trùng ở mức logic phòng trường hợp class/style bị thay đổi
      if (getSelectedPlayerIdMap()[String(id)]) return;

      if (currentSlotIndex !== null && window.TeamBuilder) {
        window.TeamBuilder.setPlayer(currentSlotIndex, {
          id: id,
          name: name,
          avatar: PLAYER_IMG_DIR + id + PLAYER_IMG_EXT,
        });
      }
      $popup.removeClass("active");
    });

    // Lắng nghe event từ TeamBuilder để mở popup
    $(document).on("builder:openSelectPlayer", function (e, index) {
      openPopup(index);
    });
  })($);
});
